webpackJsonp([14,151],{

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__ = __webpack_require__(3492);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c31155_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__ = __webpack_require__(4010);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3991)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73c31155"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c31155_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/Chat.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73c31155", Component.options)
  } else {
    hotAPI.reload("data-v-73c31155", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ES_CURRENCY */
/* unused harmony export MX_CURRENCY */
/* unused harmony export PT_CURRENCY */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrencyByDomain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_domainExtensions__ = __webpack_require__(1289);
var ES_CURRENCY='€';var MX_CURRENCY='$';var PT_CURRENCY='€';function getCurrencyByDomain(){return window.location.href.includes(__WEBPACK_IMPORTED_MODULE_0__constants_domainExtensions__["b" /* MX_DOMAIN_EXTENSION */])?MX_CURRENCY:ES_CURRENCY;}

/***/ }),

/***/ 2575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_FilesRepository__ = __webpack_require__(2583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseInput_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseRadioGroup_vue__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_es_clinic_history_json__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_es_clinic_history_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lang_es_clinic_history_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_en_clinic_history_json__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_en_clinic_history_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__lang_en_clinic_history_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_pt_clinic_history_json__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_pt_clinic_history_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__lang_pt_clinic_history_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_locales__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_db_fileCategories__ = __webpack_require__(2584);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var UPLOAD_FROM_DEVICE_TYPE = 0;
var UPLOAD_LINK_TYPE = 1;
var FILE_TYPE = 'file';
var LINK_TYPE = 'link';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { BaseButton: __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton_vue__["default"], BaseInput: __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseInput_vue__["default"], BaseRadioGroup: __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseRadioGroup_vue__["default"], BFormFile: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["q" /* BFormFile */], BIcon: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["C" /* BIcon */] },
    watch: {
        'tagSelect.value': function tagSelectValue(value) {
            this.documentOrLinkValue = null;
        }
    },
    props: {
        isPartOfForm: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            tagSelect: {
                options: [],
                value: null,
                loading: false,
                filter: null
            },
            file: null,
            documentOrLinkValue: null,
            documentOrLinkOptions: [{ text: this.$t('upload-from-device'), value: UPLOAD_FROM_DEVICE_TYPE }, { text: this.$t('insert-url'), value: UPLOAD_LINK_TYPE }],
            link: {
                name: null,
                url: null
            }
        };
    },
    created: function created() {
        var _this = this;

        if (this.tagSelect.options.length === 0) {
            __WEBPACK_IMPORTED_MODULE_0__repositories_FilesRepository__["a" /* default */].getFilesTags().then(function (response) {
                var tags = response.data.filter(function (item) {
                    return item.id !== __WEBPACK_IMPORTED_MODULE_10__constants_db_fileCategories__["c" /* PRESCRIPTION */];
                });
                tags.push({ id: -1, name: { es: __WEBPACK_IMPORTED_MODULE_6__lang_es_clinic_history_json__["reportOrPrescripcion"], en: __WEBPACK_IMPORTED_MODULE_7__lang_en_clinic_history_json__["reportOrPrescripcion"], pt: __WEBPACK_IMPORTED_MODULE_8__lang_pt_clinic_history_json__["reportOrPrescripcion"] } });
                tags.push({ id: -2, name: { es: __WEBPACK_IMPORTED_MODULE_6__lang_es_clinic_history_json__["dataopensalud"], en: __WEBPACK_IMPORTED_MODULE_7__lang_en_clinic_history_json__["dataopensalud"], pt: __WEBPACK_IMPORTED_MODULE_8__lang_pt_clinic_history_json__["dataopensalud"] } });
                tags.sort(function (a, b) {
                    return _this.$i18n.locale === __WEBPACK_IMPORTED_MODULE_9__constants_locales__["a" /* EN_LOCALE */] ? a.name.en > b.name.en : _this.$i18n.locale === __WEBPACK_IMPORTED_MODULE_9__constants_locales__["d" /* PT_LOCALE */] ? a.name.pt > b.name.pt : a.name.es > b.name.es;
                });
                _this.tagSelect.options = tags;
            });
        }
    },

    methods: {
        uploadFile: function uploadFile() {
            var _this2 = this;

            if (!this.isPartOfForm) {
                Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().uploadFileToClinicHistory(this.file, this.tagSelect.value).then(function (response) {
                    _this2.$emit('refresh'); // pasaralfilesRepository, hacer la comprobación del badrequest
                });
            } else {
                this.$emit('sendFile', {
                    file: this.file,
                    data: {
                        name: this.file.name,
                        size: this.file.size,
                        type: this.file.type,
                        category: this.tagSelect.options.find(function (x) {
                            return x.id === _this2.tagSelect.value;
                        }),
                        fileType: FILE_TYPE,
                        url: URL.createObjectURL(this.file)
                    }
                });
            }
            this.resetForm();
        },
        uploadLink: function uploadLink() {
            var _this3 = this;

            if (!this.link.name) {
                this.$store.dispatch('showDangerAlert', this.$t('link.nameError'));
            } else if (!this.link.url || !this.$validators.validateUrl(this.link.url)) {
                this.$store.dispatch('showDangerAlert', this.$t('link.linkError'));
            } else {
                if (!this.isPartOfForm) {
                    var data = { fileCategory: this.tagSelect.value, link: this.link };
                    Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().saveApps(data).then(function (response) {
                        _this3.$emit('refresh');
                    });
                } else {
                    this.link.category = this.tagSelect.options.find(function (x) {
                        return x.id === _this3.tagSelect.value;
                    });
                    this.link.fileType = LINK_TYPE;
                    this.$emit('sendFile', {
                        data: this.link
                    });
                }
                this.resetForm();
            }
        },
        resetForm: function resetForm() {
            this.tagSelect.value = null;
            this.file = null;
            this.link = { name: null, url: null };
        }
    },
    computed: {
        showUploadLinkBox: function showUploadLinkBox() {
            return __WEBPACK_IMPORTED_MODULE_10__constants_db_fileCategories__["b" /* LINK_TYPES */].includes(this.tagSelect.value) || this.showDocumentOrLinkSelector && this.documentOrLinkValue === UPLOAD_LINK_TYPE;
        },
        showUploadBox: function showUploadBox() {
            return !__WEBPACK_IMPORTED_MODULE_10__constants_db_fileCategories__["b" /* LINK_TYPES */].includes(this.tagSelect.value) && !this.showDocumentOrLinkSelector || this.showDocumentOrLinkSelector && this.documentOrLinkValue === UPLOAD_FROM_DEVICE_TYPE;
        },
        showDocumentOrLinkSelector: function showDocumentOrLinkSelector() {
            return __WEBPACK_IMPORTED_MODULE_10__constants_db_fileCategories__["a" /* LINK_OR_FILE */].includes(this.tagSelect.value);
        }
    }
});

/***/ }),

/***/ 2583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(283);
var client=__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;/* harmony default export */ __webpack_exports__["a"] = ({getFiles:function getFiles(){var fileId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return client.get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('files',fileId));},getFilesTags:function getFilesTags(){var isApp=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return client.get('fileTags',{params:{isApp:isApp}});},getImage:function getImage(fileId){return client.get('files/downloadImage',{params:{id:fileId}});},markLinkAsReaded:function markLinkAsReaded(linkId){return client.get('files/markLinkAsReaded',{params:{linkId:linkId}});}});

/***/ }),

/***/ 2584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLINIC_HISTORY_SUMMARY */
/* unused harmony export EXTERNAL_CLINIC_REPORT */
/* unused harmony export LAB_TESTS_RESULTS_REPORT */
/* unused harmony export IMAGE_TESTS_RESULTS_REPORT */
/* unused harmony export X_RAYS */
/* unused harmony export SCANNER_TAC */
/* unused harmony export MAGNETIC_RESONANCE */
/* unused harmony export PET_SPECT */
/* unused harmony export OTHER_TESTS */
/* unused harmony export IMAGE */
/* unused harmony export OTHER_DOCUMENT */
/* unused harmony export RECOMMENDED_READING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRESCRIPTION; });
/* unused harmony export TELEMEDCARE_REPORT */
/* unused harmony export DIGITAL_STETHOSCOPE_RECORDING */
/* unused harmony export SCAN_LAMP_IMAGE */
/* unused harmony export SLEEP_PLAN */
/* unused harmony export SLEEP_CERTIFICATE */
/* unused harmony export CLINICAL_ANALYSIS */
/* unused harmony export DOCUMENT_TO_COMPLETE_BY_PATIENT */
/* unused harmony export DOCUMENT_COMPLETED_BY_PATIENT */
/* unused harmony export FORM_TO_COMPLETE_BY_PATIENT */
/* unused harmony export FORM_COMPLETED_BY_PATIENT */
/* unused harmony export USEFUL_LINK */
/* unused harmony export GENETIC_TEST */
/* unused harmony export REPORT */
/* unused harmony export BILL */
/* unused harmony export RECOMMENDED_APPS */
/* unused harmony export DERMATOLOGICAL_IMAGE */
/* unused harmony export EXERCISE_RECOMMENDATIONS */
/* unused harmony export PHOTOGRAPHIC_DIETARY_RECORD */
/* unused harmony export NUTRITIONAL_RECOMMENDATIONS */
/* unused harmony export TREATMENT_INFORMATION */
/* unused harmony export GENOGRAM */
/* unused harmony export EXERCISE_PLAN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINK_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LINK_OR_FILE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isDocumentOrLink;
/* harmony export (immutable) */ __webpack_exports__["f"] = isDocumentOrLinkPendingComplete;
/* harmony export (immutable) */ __webpack_exports__["e"] = isDocumentOrLinkCompleted;
var CLINIC_HISTORY_SUMMARY=1;var EXTERNAL_CLINIC_REPORT=2;var LAB_TESTS_RESULTS_REPORT=3;var IMAGE_TESTS_RESULTS_REPORT=4;var X_RAYS=5;var SCANNER_TAC=6;var MAGNETIC_RESONANCE=7;var PET_SPECT=8;var OTHER_TESTS=9;var IMAGE=10;var OTHER_DOCUMENT=11;var RECOMMENDED_READING=12;var PRESCRIPTION=13;var TELEMEDCARE_REPORT=14;var DIGITAL_STETHOSCOPE_RECORDING=15;var SCAN_LAMP_IMAGE=16;var SLEEP_PLAN=17;var SLEEP_CERTIFICATE=18;var CLINICAL_ANALYSIS=19;var DOCUMENT_TO_COMPLETE_BY_PATIENT=20;var DOCUMENT_COMPLETED_BY_PATIENT=21;var FORM_TO_COMPLETE_BY_PATIENT=22;var FORM_COMPLETED_BY_PATIENT=23;var USEFUL_LINK=24;var GENETIC_TEST=25;var REPORT=26;var BILL=27;var RECOMMENDED_APPS=28;var DERMATOLOGICAL_IMAGE=29;var EXERCISE_RECOMMENDATIONS=30;var PHOTOGRAPHIC_DIETARY_RECORD=31;var NUTRITIONAL_RECOMMENDATIONS=32;var TREATMENT_INFORMATION=33;var GENOGRAM=118;var EXERCISE_PLAN=119;var LINK_TYPES=[USEFUL_LINK,RECOMMENDED_APPS];var LINK_OR_FILE=[DOCUMENT_TO_COMPLETE_BY_PATIENT,DOCUMENT_COMPLETED_BY_PATIENT,FORM_TO_COMPLETE_BY_PATIENT,FORM_COMPLETED_BY_PATIENT];function isDocumentOrLink(documentType){return[DOCUMENT_TO_COMPLETE_BY_PATIENT,DOCUMENT_COMPLETED_BY_PATIENT,FORM_TO_COMPLETE_BY_PATIENT,FORM_COMPLETED_BY_PATIENT,USEFUL_LINK,RECOMMENDED_APPS].some(function(f){return f===documentType;});}function isDocumentOrLinkPendingComplete(documentType){return[DOCUMENT_TO_COMPLETE_BY_PATIENT,FORM_TO_COMPLETE_BY_PATIENT].some(function(f){return f===documentType;});}function isDocumentOrLinkCompleted(documentType){return[DOCUMENT_COMPLETED_BY_PATIENT,FORM_COMPLETED_BY_PATIENT].some(function(f){return f===documentType;});}

/***/ }),

/***/ 2599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
var client=function client(){return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api;};/* harmony default export */ __webpack_exports__["a"] = ({isFirstAppointment:function isFirstAppointment(profId){return client().get('appointments/isFirstAppointment',{profId:profId});},getAppointmentReport:function getAppointmentReport(appointmentId){return client().get('/patientReportPDF',{params:{appointmentId:appointmentId}});},getAppointmentPrescription:function getAppointmentPrescription(appointmentId){return client().get('/prescriptions/'+appointmentId,{responseType:'blob'});},getNextPatientAppointments:function getNextPatientAppointments(hideLoadingIcon){return client().get('/patients/appointments/next',{loading:!hideLoadingIcon});},getPastPatientAppointments:function getPastPatientAppointments(_ref){var fromDate=_ref.fromDate,toDate=_ref.toDate,professionalName=_ref.professionalName,appointmentType=_ref.appointmentType;return client().get('/patients/appointments/past',{params:{fromDate:fromDate,toDate:toDate,professionalName:professionalName,appointmentType:appointmentType}});},getAppointmentDetails:function getAppointmentDetails(appointmentId){return client().get('appointment-details/'+appointmentId);},cancelAppointment:function cancelAppointment(appointmentId,reason){return client().post('PatientCancelationAppointment',{AppointmentId:appointmentId,Reason:reason});},getAppointmentRequestInfo:function getAppointmentRequestInfo(){var criteria=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{profId:profId,centerId:centerId,appointmentTypeId:appointmentTypeId,serviceId:serviceId};var cleanCriteria=Object.fromEntries(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(criteria).filter(function(_ref2){var _ref3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2,2),_=_ref3[0],v=_ref3[1];return v!==undefined&&v!==null&&v!=='';}));return client().get('appointments/appointment-requests',{params:cleanCriteria});},createAppointment:function createAppointment(data){return client().post('appointments/appointment-requests',data);}});

/***/ }),

/***/ 2642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFileSelect_vue__ = __webpack_require__(2575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d64efd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFileSelect_vue__ = __webpack_require__(2645);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2643)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d64efd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFileSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d64efd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFileSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/UploadFileSelect.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d64efd2", Component.options)
  } else {
    hotAPI.reload("data-v-2d64efd2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2643:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2644);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3e961ebc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d64efd2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UploadFileSelect.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d64efd2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UploadFileSelect.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2644:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-2d64efd2]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-2d64efd2],.slide-down-leave-active[data-v-2d64efd2]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-2d64efd2],.slide-down-leave-to[data-v-2d64efd2]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-2d64efd2],.slide-fade-left-leave-active[data-v-2d64efd2]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-2d64efd2],.slide-fade-left-leave-to[data-v-2d64efd2]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-2d64efd2]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-2d64efd2],.fade-leave-to[data-v-2d64efd2]{opacity:0\n}\n", ""]);

// exports


/***/ }),

/***/ 2645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isPartOfForm
      ? _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("attach-file")))])])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: [_vm.isPartOfForm ? "w-100" : "col-lg-7 col-12 p-1"] },
      [
        _c("base-select", {
          attrs: {
            searchable: "",
            loading: _vm.tagSelect.loading,
            options: _vm.tagSelect.options,
            label: _vm.$i18nHelpers.normalizeProp("name"),
            valueProp: "id",
            placeholder: _vm.$t("select-file-type"),
            clearable: ""
          },
          model: {
            value: _vm.tagSelect.value,
            callback: function($$v) {
              _vm.$set(_vm.tagSelect, "value", $$v)
            },
            expression: "tagSelect.value"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.tagSelect.value
      ? _c(
          "div",
          [
            _vm.showDocumentOrLinkSelector
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.isPartOfForm
                        ? "d-flex justify-content-center"
                        : "col-lg-7 col-12 p-1"
                    ]
                  },
                  [
                    _c("base-radio-group", {
                      attrs: { options: _vm.documentOrLinkOptions },
                      model: {
                        value: _vm.documentOrLinkValue,
                        callback: function($$v) {
                          _vm.documentOrLinkValue = $$v
                        },
                        expression: "documentOrLinkValue"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showUploadBox
              ? _c("b-form-file", {
                  class: [
                    "mt-2",
                    _vm.isPartOfForm ? "w-100" : "col-lg-7 col-12"
                  ],
                  attrs: {
                    placeholder: _vm.$t("select-or-drag-drop-file"),
                    "drop-placeholder": _vm.$t("drag-drop-file"),
                    "browse-text": _vm.$t("browse")
                  },
                  on: { input: _vm.uploadFile },
                  model: {
                    value: _vm.file,
                    callback: function($$v) {
                      _vm.file = $$v
                    },
                    expression: "file"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showUploadLinkBox
              ? _c("div", { staticClass: "col-12 p-1 mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("base-input", {
                        staticClass: "col-12 col-md-5 pr-2 mb-2",
                        attrs: {
                          zeroMarginBottom: "",
                          placeholder: _vm.$t("name")
                        },
                        model: {
                          value: _vm.link.name,
                          callback: function($$v) {
                            _vm.$set(_vm.link, "name", $$v)
                          },
                          expression: "link.name"
                        }
                      }),
                      _vm._v(" "),
                      _c("base-input", {
                        staticClass: "col-12 col-md-5 px-2 mb-2",
                        attrs: {
                          zeroMarginBottom: "",
                          placeholder: "URL (http://...)"
                        },
                        model: {
                          value: _vm.link.url,
                          callback: function($$v) {
                            _vm.$set(_vm.link, "url", $$v)
                          },
                          expression: "link.url"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass: "w-100",
                              on: { click: _vm.uploadLink }
                            },
                            [
                              _vm.isPartOfForm
                                ? _c("b-icon-plus-lg")
                                : _c("span", [_vm._v(_vm._s(_vm.$t("save")))])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d64efd2", esExports)
  }
}

/***/ }),

/***/ 2679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
var client=__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;/* harmony default export */ __webpack_exports__["a"] = ({getProfessionals:function getProfessionals(params,hideLoadingIcon){return client.get('search/professionals',{params:params,loading:!hideLoadingIcon});},getCompaniesProfessionals:function getCompaniesProfessionals(params,hideLoadingIcon){return client.get('search/companiesProfessionals',{params:params,loading:!hideLoadingIcon});},getCenters:function getCenters(params,hideLoadingIcon){return client.get('search/centers',{params:params,loading:!hideLoadingIcon});},getCentersAndProfs:function getCentersAndProfs(params,hideLoadingIcon){return client.get('search/centersAndProfessionals',{params:params,loading:!hideLoadingIcon});},getProfsByName:function getProfsByName(name){return client.get('search/professionals-basic-info',{params:{name:name}});},getCentersByName:function getCentersByName(name){return client.get('search/centersByName',{params:{name:name}});},getProfById:function getProfById(profId){return client.get('search/professionals-basic-info/'+profId);},getPatientById:function getPatientById(patientId){return client.get('search/patient-basic-info/'+patientId);}});

/***/ }),

/***/ 2746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_BaseDialog_vue__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BBadge: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["b" /* BBadge */],
        BaseDialog: __WEBPACK_IMPORTED_MODULE_2__components_base_BaseDialog_vue__["default"]
    },
    props: {
        hasInterconsultations: {
            type: Boolean,
            default: false
        },
        loggedProfAllowInterconsultations: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            profServices: [{
                name: this.$t('professionalServices.sendMessage'),
                icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/chat.svg',
                active: true,
                action: this.sendMessage
            }, {
                name: this.$t('professionalServices.interconsultation'),
                icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/interconsultations.svg',
                active: this.hasInterconsultations,
                action: this.createInterconsultation
            }, {
                name: this.$t('professionalServices.facilityRent'),
                icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/facility-rent.svg',
                active: this.hasInterconsultations,
                action: this.checkFacilities
            }],
            blinkSoonLabelActive: false,
            activateInterconsultationsModal: false,
            BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_1__constants_colours__["c" /* BLUE_COLOUR */]
        };
    },

    methods: {
        sendMessage: function sendMessage() {
            this.$emit('showInterconsultationModal', false);
        },
        createInterconsultation: function createInterconsultation() {
            if (this.loggedProfAllowInterconsultations) {
                this.$emit('showInterconsultationModal', true);
            } else {
                this.activateInterconsultationsModal = true;
            }
        },
        checkFacilities: function checkFacilities() {
            this.highlightSoonLabel();
        },
        highlightSoonLabel: function highlightSoonLabel() {
            var _this = this;

            this.blinkSoonLabelActive = true;
            setTimeout(function () {
                _this.blinkSoonLabelActive = false;
            }, 4000);
        }
    },
    computed: {
        activeServices: function activeServices() {
            return this.profServices.filter(function (s) {
                return s.active;
            });
        },
        iconSize: function iconSize() {
            return !this.$uiHelpers.isXlDevice ? '30' : '40';
        }
    }
});

/***/ }),

/***/ 2747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_forms_UploadFileSelect_vue__ = __webpack_require__(2642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { UploadFileSelect: __WEBPACK_IMPORTED_MODULE_1__components_base_forms_UploadFileSelect_vue__["a" /* default */], BIcon: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["C" /* BIcon */], PaginatedTable: __WEBPACK_IMPORTED_MODULE_2__components_base_PaginatedTable__["a" /* default */] },
    props: {
        value: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        var _this = this;

        return {
            tableFields: [{
                label: '',
                key: 'icon'
            }, {
                label: this.$t('name'),
                key: 'fileName'
            }, {
                label: this.$t('file-type-column'),
                key: 'data.category.name',
                formatter: function formatter(value, key, item) {
                    return !value ? _this.$t('undefined') : _this.$i18nHelpers.normalize(value);
                }
            }, {
                label: '',
                key: 'remove'
            }]
        };
    },

    methods: {
        addFileOrUpload: function addFileOrUpload(file) {
            this.emitUpdatedValue([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value), [file]));
        },
        removeFile: function removeFile(index) {
            this.emitUpdatedValue(this.value.filter(function (_, i) {
                return i !== index;
            }));
        },
        emitUpdatedValue: function emitUpdatedValue(newValue) {
            this.$emit('input', newValue);
        },
        openFile: function openFile(url) {
            window.open(url.indexOf('http') > -1 ? url : 'http://' + url, '_blank');
        }
    }
});

/***/ }),

/***/ 2777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
var client=function client(){return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;};/* harmony default export */ __webpack_exports__["a"] = ({notifyProfessionalDisabledTarifaPlus:function notifyProfessionalDisabledTarifaPlus(params){return client().post('professionals/NotifyProfessionalDisabledTarifaPlus',params);},notifyPrevalidatedProfessional:function notifyPrevalidatedProfessional(params){return client().post('professionals/NotifyProfessionalPrevalidated',params);},getProfPatients:function getProfPatients(name){return client().get('professionals/GetProfessionalPatients',{params:{name:name}});}});

/***/ }),

/***/ 2788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBlocksProfessional_vue__ = __webpack_require__(2746);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2b14a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBlocksProfessional_vue__ = __webpack_require__(2958);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2956)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a2b14a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBlocksProfessional_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2b14a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBlocksProfessional_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/professional/interconsultations/SearchBlocksProfessional.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a2b14a0", Component.options)
  } else {
    hotAPI.reload("data-v-1a2b14a0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2956:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2957);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("21330dce", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a2b14a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SearchBlocksProfessional.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a2b14a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SearchBlocksProfessional.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2957:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-1a2b14a0]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-1a2b14a0],.slide-down-leave-active[data-v-1a2b14a0]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-1a2b14a0],.slide-down-leave-to[data-v-1a2b14a0]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-1a2b14a0],.slide-fade-left-leave-active[data-v-1a2b14a0]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-1a2b14a0],.slide-fade-left-leave-to[data-v-1a2b14a0]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-1a2b14a0]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-1a2b14a0],.fade-leave-to[data-v-1a2b14a0]{opacity:0\n}\n.service-type-block[data-v-1a2b14a0]{text-align:center;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);padding:1.5rem 0.5rem;border-radius:23px;border:1px solid #eee;background-color:#eee;-ms-flex-preferred-size:50%;flex-basis:50%;font-size:11px;cursor:pointer;color:#3238C4;max-width:220px\n}\n.icon-service[data-v-1a2b14a0]{width:36px;height:36px\n}\n.blue[data-v-1a2b14a0]{color:#3238C4\n}\n.bold[data-v-1a2b14a0]{font-weight:bold\n}\n.service-name[data-v-1a2b14a0]{color:#3238C4;font-weight:bold;text-transform:uppercase\n}\n.service-type[data-v-1a2b14a0]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:1.8rem;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row\n}\n@media only screen and (max-width: 1199px){\n.service-type[data-v-1a2b14a0]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 2958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-type" },
    [
      _c(
        "base-dialog",
        {
          attrs: {
            okBtnText: _vm.$t("chats.go-my-services"),
            okFn: function() {
              _vm.$helpers.goToWebApp(
                "HomeProfesional#/services",
                _vm.$apiToken
              )
            },
            cancelFn: function() {
              _vm.activateInterconsultationsModal = false
            }
          },
          model: {
            value: _vm.activateInterconsultationsModal,
            callback: function($$v) {
              _vm.activateInterconsultationsModal = $$v
            },
            expression: "activateInterconsultationsModal"
          }
        },
        [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("chats.go-activate-interconsultations"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.activeServices, function(service) {
        return _c(
          "div",
          {
            key: service.name,
            staticClass: "service-type-block",
            on: { click: service.action }
          },
          [
            _c("base-icon", {
              staticClass: "d-block mb-3",
              attrs: {
                src: service.icon,
                alt: "",
                height: _vm.iconSize,
                width: _vm.iconSize,
                color: _vm.BLUE_COLOUR
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "service-name mt-1",
              domProps: { innerHTML: _vm._s(service.name) }
            }),
            _vm._v(" "),
            service.name === _vm.$t("professionalServices.facilityRent")
              ? _c(
                  "b-badge",
                  {
                    class: { blink: _vm.blinkSoonLabelActive },
                    attrs: { variant: "primary" }
                  },
                  [_vm._v(_vm._s(_vm.$t("soon-label")))]
                )
              : _vm._e()
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a2b14a0", esExports)
  }
}

/***/ }),

/***/ 2965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_BaseDialog__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_SearchRepository__ = __webpack_require__(2679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_ProfessionalRepository__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_forms_UploadFileGroupForm__ = __webpack_require__(2966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseTextarea_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_webapp_professional_interconsultations_SearchBlocksProfessional_vue__ = __webpack_require__(2788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_roles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_file_helpers__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_string_helpers__ = __webpack_require__(529);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BaseDialog: __WEBPACK_IMPORTED_MODULE_3__components_base_BaseDialog__["default"],
    BaseTextarea: __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseTextarea_vue__["default"],
    UploadFileGroupForm: __WEBPACK_IMPORTED_MODULE_6__components_base_forms_UploadFileGroupForm__["a" /* default */],
    SearchBlocksProfessional: __WEBPACK_IMPORTED_MODULE_8__components_webapp_professional_interconsultations_SearchBlocksProfessional_vue__["a" /* default */]
  },
  props: {
    isChatWithProf: {
      type: Boolean,
      default: true
    },
    selectedProf: {
      type: Object,
      required: false
    },
    openedFromOuicare: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      interconsultationPatient: {
        loading: false,
        options: [],
        value: null
      },
      createChatUser: {
        loading: false,
        options: [],
        value: null
      },
      fileObjects: [],
      subject: null,
      newMessage: null,
      interconsultation: false,
      profChatTypeSelected: false,
      firstTimeOpen: true
    };
  },

  watch: {
    'selectedProf': function selectedProf(value) {
      this.setPickedUserData(value);
    }
  },
  created: function created() {
    var _this = this;

    if (this.openedFromOuicare) {
      if (this.$route.query.professionalId) {
        __WEBPACK_IMPORTED_MODULE_4__repositories_SearchRepository__["a" /* default */].getProfById(this.$route.query.professionalId).then(function (response) {
          _this.setPickedUserData(response.data);
        });
      } else if (this.$route.query.patientId) {
        __WEBPACK_IMPORTED_MODULE_4__repositories_SearchRepository__["a" /* default */].getPatientById(this.$route.query.patientId).then(function (response) {
          _this.setPickedUserData(response.data);
        });
      }
    }
  },

  methods: {
    setPickedUserData: function setPickedUserData(userInfo) {
      this.$set(this.createChatUser, 'options', [userInfo]);
      this.$set(this.createChatUser, 'value', userInfo.id);
      this.checkIfInterconsultation(userInfo.interconsultation);
    },
    searchUserToChatWith: function searchUserToChatWith(name) {
      if (this.isChatWithProf) {
        this.searchProfByName(name);
      } else {
        this.searchPatientByName(name);
      }
    },
    searchPatientByName: function searchPatientByName(name) {
      var _this2 = this;

      if (name && name.length >= 3) {
        __WEBPACK_IMPORTED_MODULE_5__repositories_ProfessionalRepository__["a" /* default */].getProfPatients(name).then(function (response) {
          if (_this2.isChatWithProf) {
            _this2.interconsultationPatient.options = response.data;
          } else {
            _this2.createChatUser.options = response.data;
          }
        });
      }
    },
    searchProfByName: function searchProfByName(name) {
      var _this3 = this;

      if (name && name.length >= 3) {
        __WEBPACK_IMPORTED_MODULE_4__repositories_SearchRepository__["a" /* default */].getProfsByName(name).then(function (response) {
          _this3.createChatUser.options = response.data;
        });
      }
    },
    getUserPhoto: function getUserPhoto(options, id) {
      var user = options.find(function (item) {
        return item.id === id;
      });
      return user.photo || this.defaultImg;
    },
    checkIfInterconsultation: function checkIfInterconsultation(isInterconsultation) {
      this.interconsultation = isInterconsultation;
      this.profChatTypeSelected = true;
    },
    createChat: function createChat() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var filesAndLinks, chatObject;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.createChatUser.value) {
                  _context.next = 4;
                  break;
                }

                _this4.$store.dispatch('showDangerAlert', _this4.$t('chats.user-not-selected'));
                _context.next = 14;
                break;

              case 4:
                if (_this4.newMessage) {
                  _context.next = 8;
                  break;
                }

                _this4.$store.dispatch('showDangerAlert', _this4.$t('chats.message-not-written'));
                _context.next = 14;
                break;

              case 8:
                _context.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_11__helpers_file_helpers__["a" /* getFilesAndLinks */])(_this4.fileObjects);

              case 10:
                filesAndLinks = _context.sent;
                chatObject = {
                  reason: _this4.newMessage,
                  interconsultation: _this4.interconsultation ? {
                    patientId: _this4.interconsultationPatient.value,
                    facilityId: null,
                    subject: _this4.subject
                  } : null,
                  files: filesAndLinks.files,
                  links: filesAndLinks.links
                };

                if (_this4.isChatWithProf) chatObject.askedProfessional = _this4.createChatUser.value;else chatObject.askedPatient = _this4.createChatUser.value;
                __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].createChat(chatObject).then(function (response) {
                  if (!response.data) {
                    throw response.response.data;
                  }
                  if (_this4.$route.path.includes('/professional-network')) {
                    _this4.$router.push({ name: 'ProfessionalChat', params: { role: __WEBPACK_IMPORTED_MODULE_10__constants_roles__["h" /* PROFESSIONAL_ROLE */] } });
                  } else {
                    _this4.$emit('createAdministrativeChat', response.data);
                  }
                  _this4.$store.dispatch('showSuccessAlert', _this4.$t('chats.create-prof-chat-success'));
                  _this4.resetValues();
                }).catch(function (error) {
                  var msgAppend = error.includes('already-active-chat') ? ' - ' + _this4.$t('chats.already-active-chat') : '';
                  _this4.$store.dispatch('showDangerAlert', '' + _this4.$t('chats.create-prof-chat-fail') + msgAppend);
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    nameFilter: function nameFilter(options, search) {
      if (search && search.length >= 3) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(options.filter(function (option) {
          return Object(__WEBPACK_IMPORTED_MODULE_12__helpers_string_helpers__["b" /* checkIgnoringNonRelevantCharactersFromOptionLabel */])(option, search) > -1;
        })));
      }
    },
    resetValues: function resetValues() {
      this.interconsultationPatient = {
        loading: false,
        options: [],
        value: null
      };
      this.createChatUser = {
        loading: false,
        options: [],
        value: null
      };
      this.fileObjects = [];
      this.subject = null;
      this.newMessage = null;
      this.interconsultation = false;
      this.profChatTypeSelected = false;
      this.firstTimeOpen = false;
    }
  },
  computed: {
    defaultImg: function defaultImg() {
      return this.isChatWithProf ? '/static-appopensalud/img/icons/morillas-svg-icons/primary/doctor.svg' : '/static-appopensalud/img/icons/morillas-svg-icons/primary/user.svg';
    },
    modalTitle: function modalTitle() {
      return this.$t('chats.administrative-chat') + ' - ' + (this.isChatWithProf ? this.$t('professional') : this.$t('patient'));
    },
    isUserSelectorDisabled: function isUserSelectorDisabled() {
      return this.createChatUser.value !== null && this.modalOpenedFromOutsideButton;
    },
    showOptionsBlock: function showOptionsBlock() {
      return !this.modalOpenedFromOutsideButton && this.isChatWithProf && !this.profChatTypeSelected && !this.firstTimeOpen;
    },
    keepOpenedModal: function keepOpenedModal() {
      return !this.modalOpenedFromOutsideButton && this.isChatWithProf && this.profChatTypeSelected && !this.firstTimeOpen;
    },
    modalOpenedFromOutsideButton: function modalOpenedFromOutsideButton() {
      return !!this.selectedProf || this.openedFromOuicare;
    }
  }
});

/***/ }),

/***/ 2966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFileGroupForm_vue__ = __webpack_require__(2747);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b37798_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFileGroupForm_vue__ = __webpack_require__(2969);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2967)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32b37798"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFileGroupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b37798_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFileGroupForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/UploadFileGroupForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32b37798", Component.options)
  } else {
    hotAPI.reload("data-v-32b37798", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2967:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2968);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("f28ca8d4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32b37798\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UploadFileGroupForm.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32b37798\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UploadFileGroupForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2968:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-32b37798]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-32b37798],.slide-down-leave-active[data-v-32b37798]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-32b37798],.slide-down-leave-to[data-v-32b37798]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-32b37798],.slide-fade-left-leave-active[data-v-32b37798]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-32b37798],.slide-fade-left-leave-to[data-v-32b37798]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-32b37798]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-32b37798],.fade-leave-to[data-v-32b37798]{opacity:0\n}\n", ""]);

// exports


/***/ }),

/***/ 2969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("upload-file-select", {
        attrs: { isPartOfForm: "" },
        on: { sendFile: _vm.addFileOrUpload }
      }),
      _vm._v(" "),
      _vm.value && _vm.value.length
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("paginated-table", {
                attrs: {
                  fields: _vm.tableFields,
                  items: _vm.value,
                  showCaption: false
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(icon)",
                      fn: function(data) {
                        return [
                          data.item.data.fileType === "link"
                            ? _c("b-icon-link45deg", {
                                attrs: { variant: "primary" }
                              })
                            : data.item.data.fileType.includes("image")
                            ? _c("b-icon-image", {
                                attrs: { variant: "primary" }
                              })
                            : data.item.data.fileType.includes("pdf")
                            ? _c("b-icon-file-earmark-pdf", {
                                attrs: { variant: "primary" }
                              })
                            : data.item.data.fileType.includes("application")
                            ? _c("b-icon-file-earmark-text", {
                                attrs: { variant: "primary" }
                              })
                            : _c("b-icon-folder", {
                                attrs: { variant: "primary" }
                              })
                        ]
                      }
                    },
                    {
                      key: "cell(fileName)",
                      fn: function(data) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "clickable",
                              on: {
                                click: function($event) {
                                  return _vm.openFile(data.item.data.url)
                                }
                              }
                            },
                            [_vm._v(_vm._s(data.item.data.name))]
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(remove)",
                      fn: function(data) {
                        return [
                          _c("b-icon-trash", {
                            staticClass: "clickable",
                            attrs: { variant: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.removeFile(data.index)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  589695012
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32b37798", esExports)
  }
}

/***/ }),

/***/ 2977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_db_cancelationReasons__ = __webpack_require__(3131);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BModal: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_32" /* BModal */],
    BRow: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_45" /* BRow */],
    'base-checkbox': function baseCheckbox() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 518));
    },
    'base-select': function baseSelect() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 515));
    },
    'base-button': function baseButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 122));
    }
  },
  props: {
    value: [Boolean],
    isBillable: {
      type: Boolean,
      required: false,
      default: false
    },
    billingEntity: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      selectedBillingEntity: null,
      noChargeCheckboxValue: false,
      noChargeOptions: [],
      noChargeSelectedReason: null,
      billingEntities: []
    };
  },

  methods: {
    consolidate: function consolidate() {
      this.visible = false;
      if (this.isBillable && !this.noChargeCheckboxValue && !this.selectedBillingEntity) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-select-billable-entity'));
      } else if (this.isBillable && this.noChargeCheckboxValue && !this.noChargeSelectedReason) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-specify-not-charge-reason'));
      } else {
        this.$emit('consolidate', { BillingEntityId: this.selectedBillingEntity, NoChargeReasonId: this.noChargeSelectedReason });
      }
    },
    noChargeToggled: function noChargeToggled() {
      var _this = this;

      if (!this.noChargeCheckboxValue && this.noChargeOptions.length === 0) {
        this.$api('NoChargeReasons').then(function (response) {
          _this.noChargeOptions = response.data.data;
        });
      }
    },
    loadBillableEntities: function loadBillableEntities() {
      var _this2 = this;

      if (this.billingEntities.length === 0) {
        this.$api('webapp/BillingEntities').then(function (response) {
          _this2.billingEntities = response.data.data;
          if (_this2.billingEntity) {
            var matched = _this2.billingEntities.find(function (x) {
              return x.value === _this2.billingEntity;
            });
            if (matched) _this2.selectedBillingEntity = matched.value;
          }
        });
      }
    }
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    noChargeSelectedReasonIsTechnicalType: function noChargeSelectedReasonIsTechnicalType() {
      return __WEBPACK_IMPORTED_MODULE_1__constants_db_cancelationReasons__["a" /* TECHNICAL_REASONS */].includes(parseInt(this.noChargeSelectedReason)) || this.billingEntity != null;
    }
  }
});

/***/ }),

/***/ 3106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdministrativeChatModal_vue__ = __webpack_require__(2965);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0016e43a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdministrativeChatModal_vue__ = __webpack_require__(3109);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3107)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0016e43a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdministrativeChatModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0016e43a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdministrativeChatModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/AdministrativeChatModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0016e43a", Component.options)
  } else {
    hotAPI.reload("data-v-0016e43a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3107:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("f69ae00c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0016e43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdministrativeChatModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0016e43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdministrativeChatModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3108:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-0016e43a]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-0016e43a],.slide-down-leave-active[data-v-0016e43a]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-0016e43a],.slide-down-leave-to[data-v-0016e43a]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-0016e43a],.slide-fade-left-leave-active[data-v-0016e43a]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-0016e43a],.slide-fade-left-leave-to[data-v-0016e43a]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-0016e43a]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-0016e43a],.fade-leave-to[data-v-0016e43a]{opacity:0\n}\n.photo-option[data-v-0016e43a]{border-radius:50%;padding:0;width:30px;height:30px\n}\ndiv.form-group[data-v-0016e43a]{margin-bottom:0.75rem !important\n}\n[data-v-0016e43a] .service-prof-type{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n", ""]);

// exports


/***/ }),

/***/ 3109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            title: _vm.modalTitle,
            okBtnText: _vm.$t("create"),
            okBtnVariant: "success",
            cancelBtnText: _vm.$t("back"),
            cancelBtnVariant: "secondary",
            keepOpened: _vm.keepOpenedModal,
            okFn: function() {
              _vm.createChat()
            },
            cancelFn: function() {
              _vm.resetValues()
            }
          },
          model: {
            value: _vm.$store.state.chat.showDialog.create,
            callback: function($$v) {
              _vm.$set(_vm.$store.state.chat.showDialog, "create", $$v)
            },
            expression: "$store.state.chat.showDialog.create"
          }
        },
        [
          [
            _vm.showOptionsBlock
              ? _c(
                  "div",
                  [
                    _c("search-blocks-professional", {
                      on: {
                        showInterconsultationModal: _vm.checkIfInterconsultation
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("base-select", {
                      staticClass: "mt-2",
                      attrs: {
                        searchable: "",
                        clearable: "",
                        avoidDefaultSort: "",
                        filter: _vm.nameFilter,
                        disabled: _vm.isUserSelectorDisabled,
                        loading: _vm.createChatUser.loading,
                        options: _vm.createChatUser.options,
                        valueProp: "id",
                        label: "name",
                        placeholder: _vm.isChatWithProf
                          ? _vm.$t("chats.select-prof")
                          : _vm.$t("chats.select-patient")
                      },
                      on: {
                        search: function($event) {
                          return _vm.searchUserToChatWith($event)
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function(data) {
                            return [
                              _c("div", [
                                _c("img", {
                                  staticClass: "photo-option",
                                  attrs: {
                                    src: _vm.getUserPhoto(
                                      _vm.createChatUser.options,
                                      data.option.value
                                    ),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(data.option.label))])
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.createChatUser.value,
                        callback: function($$v) {
                          _vm.$set(_vm.createChatUser, "value", $$v)
                        },
                        expression: "createChatUser.value"
                      }
                    }),
                    _vm._v(" "),
                    _vm.interconsultation
                      ? _c("base-select", {
                          staticClass: "mt-2",
                          attrs: {
                            searchable: "",
                            clearable: "",
                            avoidDefaultSort: "",
                            loading: _vm.interconsultationPatient.loading,
                            options: _vm.interconsultationPatient.options,
                            valueProp: "id",
                            label: "name",
                            placeholder: _vm.$t("chats.select-patient")
                          },
                          on: {
                            search: function($event) {
                              return _vm.searchPatientByName($event)
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "option",
                                fn: function(data) {
                                  return [
                                    _c("div", [
                                      _c("img", {
                                        staticClass: "photo-option",
                                        attrs: {
                                          src: _vm.getUserPhoto(
                                            _vm.interconsultationPatient
                                              .options,
                                            data.option.value
                                          ),
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(data.option.label))
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4203853806
                          ),
                          model: {
                            value: _vm.interconsultationPatient.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.interconsultationPatient,
                                "value",
                                $$v
                              )
                            },
                            expression: "interconsultationPatient.value"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _vm.interconsultation
                          ? _c("base-input", {
                              attrs: {
                                placeholder: _vm.$t("chats.subject"),
                                maxlength: 50
                              },
                              model: {
                                value: _vm.subject,
                                callback: function($$v) {
                                  _vm.subject = $$v
                                },
                                expression: "subject"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("base-textarea", {
                          attrs: {
                            rows: 1,
                            "max-rows": 5,
                            placeholder: _vm.$t("chats.new-message")
                          },
                          model: {
                            value: _vm.newMessage,
                            callback: function($$v) {
                              _vm.newMessage = $$v
                            },
                            expression: "newMessage"
                          }
                        }),
                        _vm._v(" "),
                        _c("upload-file-group-form", {
                          model: {
                            value: _vm.fileObjects,
                            callback: function($$v) {
                              _vm.fileObjects = $$v
                            },
                            expression: "fileObjects"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0016e43a", esExports)
  }
}

/***/ }),

/***/ 3128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsolidateAppointmentModal_vue__ = __webpack_require__(2977);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd54cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsolidateAppointmentModal_vue__ = __webpack_require__(3132);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3129)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsolidateAppointmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd54cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsolidateAppointmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/shared/ConsolidateAppointmentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72bd54cf", Component.options)
  } else {
    hotAPI.reload("data-v-72bd54cf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("f8f9eb96", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72bd54cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConsolidateAppointmentModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72bd54cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConsolidateAppointmentModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.modal-content{-webkit-transition:all linear 2.5s;transition:all linear 2.5s\n}\n", ""]);

// exports


/***/ }),

/***/ 3131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TECHNICAL_REASONS; });
/* unused harmony export UNEXPECTED_EVENT */
/* unused harmony export OTHER_REASONS */
/* unused harmony export PROFESSIONAL_DECISION */
var TECHNICAL_REASONS=[1,4];var UNEXPECTED_EVENT=[2,5];var OTHER_REASONS=[3,6];var PROFESSIONAL_DECISION=7;

/***/ }),

/***/ 3132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "cancel-disabled": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        title: _vm.$t("consolidate-modal.title")
      },
      on: { show: _vm.loadBillableEntities },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { white: "", shadow: "" },
                      on: { click: _vm.consolidate }
                    },
                    [_vm._v(_vm._s(_vm.$t("continue")))]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _vm.isBillable
          ? _c(
              "div",
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("consolidate-modal.charge-with-data")))
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    disabled: _vm.noChargeSelectedReasonIsTechnicalType,
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-billable-entity"
                    ),
                    options: _vm.billingEntities
                  },
                  model: {
                    value: _vm.selectedBillingEntity,
                    callback: function($$v) {
                      _vm.selectedBillingEntity = $$v
                    },
                    expression: "selectedBillingEntity"
                  }
                }),
                _vm._v(" "),
                _c(
                  "base-checkbox",
                  {
                    attrs: { onInput: _vm.noChargeToggled },
                    model: {
                      value: _vm.noChargeCheckboxValue,
                      callback: function($$v) {
                        _vm.noChargeCheckboxValue = $$v
                      },
                      expression: "noChargeCheckboxValue"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("consolidate-appointment-modal.no-charge")
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("base-select", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.noChargeCheckboxValue,
                      expression: "noChargeCheckboxValue"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-no-charge-reason"
                    ),
                    options: _vm.noChargeOptions
                  },
                  model: {
                    value: _vm.noChargeSelectedReason,
                    callback: function($$v) {
                      _vm.noChargeSelectedReason = $$v
                    },
                    expression: "noChargeSelectedReason"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72bd54cf", esExports)
  }
}

/***/ }),

/***/ 3492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_consultationTypes__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseInput_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_buttons_BaseButton_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChatMessage_vue__ = __webpack_require__(3993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repositories_ChipcardRepository__ = __webpack_require__(4001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_roles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_webapp_shared_CancelAppointmentModal_vue__ = __webpack_require__(4002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_webapp_shared_ConsolidateAppointmentModal_vue__ = __webpack_require__(3128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AdministrativeChatModal_vue__ = __webpack_require__(3106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ChatMessageInput_vue__ = __webpack_require__(4006);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BaseInput: __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseInput_vue__["default"],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__["default"],
    BIcon: __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["C" /* BIcon */],
    BaseButton: __WEBPACK_IMPORTED_MODULE_7__components_base_buttons_BaseButton_vue__["default"],
    ChatMessage: __WEBPACK_IMPORTED_MODULE_8__ChatMessage_vue__["a" /* default */],
    ChatMessageInput: __WEBPACK_IMPORTED_MODULE_16__ChatMessageInput_vue__["a" /* default */],
    CancelAppointmentModal: __WEBPACK_IMPORTED_MODULE_13__components_webapp_shared_CancelAppointmentModal_vue__["a" /* default */],
    ConsolidateAppointmentModal: __WEBPACK_IMPORTED_MODULE_14__components_webapp_shared_ConsolidateAppointmentModal_vue__["default"],
    AdministrativeChatModal: __WEBPACK_IMPORTED_MODULE_15__AdministrativeChatModal_vue__["a" /* default */]
  },
  props: {
    role: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_12__constants_roles__["f" /* PATIENT_ROLE */]
    }
  },
  data: function data() {
    return {
      chats: [],
      userType: this.role,
      showFinishModal: false,
      pastChatInfo: null,
      showScrollBottomButton: false,
      showInterconsultationAnchored: false,

      CHAT: __WEBPACK_IMPORTED_MODULE_2__constants_consultationTypes__["f" /* CHAT */],
      SECONDARY: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["m" /* SECONDARY */],
      PROFESSIONAL_ROLE: __WEBPACK_IMPORTED_MODULE_12__constants_roles__["h" /* PROFESSIONAL_ROLE */],
      PATIENT_ROLE: __WEBPACK_IMPORTED_MODULE_12__constants_roles__["f" /* PATIENT_ROLE */]
    };
  },

  watch: {
    '$store.state.signalr.commandReceived': function $storeStateSignalrCommandReceived(_ref) {
      var _this = this;

      var command = _ref.command,
          data = _ref.data;

      var dataSplitted = data.split(';');
      var appointmentId = parseInt(dataSplitted[0]);
      switch (command) {
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["p" /* NEW_CHAT_MESSAGE */]:
          if (this.chatInfo.idAppointment !== appointmentId) {
            this.chats.find(function (x) {
              return x.idAppointment === appointmentId;
            }).numMessagesPendingRead += 1;
          } else {
            var msgId = parseInt(dataSplitted[1]);
            __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getMessage(appointmentId, msgId).then(function (response) {
              _this.chatMessages.push(response.data);
              _this.$store.commit('chat/incrementUnreadMessages');
              _this.$nextTick(function () {
                _this.$uiHelpers.scrollBottom(_this.$refs.messageList, true);
              });
            });
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["j" /* EDIT_CHAT_MESSAGE */]:
          if (this.chatInfo.idAppointment === appointmentId) {
            var _msgId = parseInt(dataSplitted[1]);
            __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getMessage(appointmentId, _msgId).then(function (response) {
              _this.$store.commit('chat/editMessage', { msgId: _msgId, msg: response.data });
            });
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["i" /* DELETE_CHAT_MESSAGE */]:
          if (this.chatInfo.idAppointment === appointmentId) {
            var _msgId2 = parseInt(dataSplitted[1]);
            this.$store.commit('chat/deleteMessageFromChat', _msgId2);
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["f" /* CHAT_CREATED_BY_DOCTOR */]:
          __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getChatById(appointmentId).then(function (response) {
            _this.setChatFirst(response.data);
          });
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["e" /* CHAT_CONSOLIDATED */]:
          var consolidatedChat = this.chats.find(function (x) {
            return x.idAppointment === appointmentId;
          });
          consolidatedChat.terminated = true;
          consolidatedChat.reviewed = consolidatedChat.createdByDoctor != null;
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["l" /* INTERCONSULTATION_ACTION */]:
          var chat = this.chats.find(function (x) {
            return x.idAppointment === appointmentId;
          });
          var acceptedConsultation = dataSplitted[1];
          if (acceptedConsultation) {
            chat.interconsultation.accepted = true;
          } else {
            this.deleteChatFromList(appointmentId);
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["h" /* CHAT_REASSIGNED */]:
          this.deleteChatFromList(appointmentId);
          __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getChatById(appointmentId).then(function (response) {
            _this.setChatFirst(response.data);
          });
          break;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('chat/resetStateOnLoad');
    if (this.pastChat) {
      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getPastChat(this.pastChat).then(function (response) {
        _this2.chats = [response.data.chatInfo];
        _this2.pastChatInfo = response.data;
        if (response.data.chatInfo.isProfessional) _this2.userType = __WEBPACK_IMPORTED_MODULE_12__constants_roles__["h" /* PROFESSIONAL_ROLE */];
        _this2.$store.commit('chat/setChatInfo', response.data.chatInfo);
        _this2.$store.commit('chat/setChatMessages', response.data.chatMessages);
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getAllUserChats().then(function (response) {
        _this2.chats = response.data;
        if (_this2.anyActiveChats && !_this2.$uiHelpers.isPortrait) _this2.selectChat(_this2.chatList[0]);
      });
      if (this.isOpenedFromOuicare) {
        if (this.$route.query.professionalId) {
          this.userType = __WEBPACK_IMPORTED_MODULE_12__constants_roles__["h" /* PROFESSIONAL_ROLE */];
        }
        this.toggleShowDialog('create');
        this.cleanUrlFromQuery();
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var checkRef = setInterval(function () {
      if (_this3.$refs.messageList) {
        _this3.$store.commit('chat/setRefs', { msgList: _this3.$refs.messageList, msgInput: _this3.$refs.messageInput });
        clearInterval(checkRef);
      }
    }, 100);
  },

  methods: {
    cleanUrlFromQuery: function cleanUrlFromQuery() {
      var cleanUrl = this.$router.resolve({ path: this.route }).href;
      window.history.replaceState(null, '', cleanUrl);
    },
    selectChat: function selectChat(selectedChat) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!selectedChat) {
                  _this4.$store.commit('chat/resetMsg');
                  _this4.$store.commit('chat/unselectChat');
                }

                if (!_this4.pastChat) {
                  _context.next = 5;
                  break;
                }

                _this4.$store.commit('chat/setChatInfo', selectedChat);
                _this4.$store.commit('chat/setChatMessages', _this4.pastChatInfo.chatMessages);
                return _context.abrupt('return');

              case 5:
                if (!(_this4.chatInfo && selectedChat.idAppointment === _this4.chatInfo.idAppointment)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return');

              case 7:
                _this4.$store.commit('chat/resetMsg');
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getChatMessages(selectedChat.idAppointment).then(function (response) {
                  _this4.$store.commit('chat/setChatInfo', selectedChat);
                  _this4.$store.commit('chat/setChatMessages', response.data);
                  _this4.$store.commit('chat/incrementUnreadMessages', _this4.chatInfo.numMessagesPendingRead);
                  _this4.chatInfo.numMessagesPendingRead = 0;
                  _this4.$store.dispatch('notifications/get');
                  _this4.$nextTick(function () {
                    _this4.$uiHelpers.centerScreen(_this4.$refs.messageInput);
                    _this4.scrollToLastRead();
                    if (_this4.dontAttendChatButton) _this4.$store.dispatch('showInfoAlert', _this4.$t('chats.dont-attend-chat-warn'));
                  });
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    contactUser: function contactUser() {
      if (this.isChatWithProfs) {
        this.$router.push('/professional/professional-network');
      } else {
        this.toggleShowDialog('create');
      }
    },
    getPastChats: function getPastChats() {
      if (this.$store.getters['session/userIsPatient']) {
        this.$router.push({ name: 'pastAppointments', params: { filters: { appointmentType: __WEBPACK_IMPORTED_MODULE_2__constants_consultationTypes__["f" /* CHAT */] } } });
      } else {
        this.$helpers.goToProfessionalWebApp('pastChats');
      }
    },
    getAllChats: function getAllChats() {
      return this.$router.push('/' + (this.$store.getters['session/userIsPatient'] ? 'patient' : 'professional') + '/chats');
    },
    setChatFirst: function setChatFirst(chat) {
      this.chats = this.chats.filter(function (c) {
        return c.idAppointment !== chat.idAppointment;
      });
      this.chats.unshift(chat);
    },
    toggleShowDialog: function toggleShowDialog(type) {
      this.$store.commit('chat/toggleShowDialog', type);
    },
    setUserType: function setUserType(role) {
      this.userType = role;
      if (!this.$uiHelpers.isPortrait) this.selectChat(this.chatList[0]);
    },
    goToProfPage: function goToProfPage() {
      if (!this.chatInfo.searchDisabled && this.chatInfo.customPageUrl) {
        window.open(this.$helpers.getCustomPageUrl(this.chatInfo.customPageUrl));
      }
    },
    goCancelAppointment: function goCancelAppointment() {
      var path = 'appointments/cancel/' + this.chatInfo.idAppointment;
      if (this.$store.getters['session/userIsPatient']) {
        this.$helpers.goToPatientWebApp(path, this.$apiToken);
      } else {
        this.$helpers.goToProfessionalWebApp(path, this.$apiToken);
      }
    },
    finishChatMessage: function finishChatMessage() {
      this.toggleShowDialog('finish');
      if (!this.chatInfo.showBillingSelectorOnConsolidate) {
        this.consolidateChat({ BillingEntityId: null, NoChargeReasonId: null });
      } else {
        this.showFinishModal = true;
      }
    },
    emitEPrescription: function emitEPrescription() {
      __WEBPACK_IMPORTED_MODULE_10__repositories_ChipcardRepository__["a" /* default */].createChipcardSession(this.chatInfo.patientId, this.chatInfo.idAppointment).then(function (response) {
        window.open(response.data.data);
      });
    },
    createChat: function createChat(newChat) {
      this.setChatFirst(newChat);
      this.selectChat(newChat);
    },
    consolidateChat: function consolidateChat(consolidateRequest) {
      var _this5 = this;

      consolidateRequest.WithReport = false;
      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].finishChat(this.chatInfo.idAppointment, consolidateRequest).then(function (response) {
        _this5.deleteChatFromList(response.data.data);
        _this5.showFinishModal = false;
        _this5.$store.dispatch('showSuccessAlert', _this5.$t('chats.finish-chat-message-success'));
      });
    },
    deleteChatFromList: function deleteChatFromList(idAppointment) {
      this.chats = this.chats.filter(function (x) {
        return x.idAppointment !== idAppointment;
      });
      if (!this.$uiHelpers.isPortrait) this.selectChat(this.chatList[0]);
    },
    reassignChat: function reassignChat() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].reassignChat(this.chatInfo.idAppointment).then(function (response) {
        if (response.data) {
          _this6.deleteChatFromList(_this6.chatInfo.idAppointment);
        }
      });
    },
    scrollToLastRead: function scrollToLastRead() {
      var messageList = this.$refs.messageList;
      var unreadRef = this.$refs.messagesPendingRead;

      if (messageList && unreadRef && unreadRef.length > 0) {
        var containerTop = messageList.getBoundingClientRect().top;
        var elementTop = unreadRef[0].getBoundingClientRect().top;
        messageList.scrollTop = elementTop - containerTop;
      } else {
        this.$uiHelpers.scrollBottom(messageList);
      }
    },
    handleScroll: function handleScroll() {
      this.showScrollBottomButtonHandler();
      if (this.interconsultation) {
        this.interconsultationButtonVisibility();
      }
    },
    showScrollBottomButtonHandler: function showScrollBottomButtonHandler() {
      var messageList = this.$refs.messageList;
      this.showScrollBottomButton = messageList && messageList.scrollTop + messageList.clientHeight < messageList.scrollHeight - 5;
    },
    interconsultationButtonVisibility: function interconsultationButtonVisibility() {
      if (this.$refs.interconsultationButton[0]) {
        var messageList = this.$refs.messageList;
        var interconsultationButton = this.$refs.interconsultationButton[0].$el;
        this.showInterconsultationAnchored = interconsultationButton.offsetTop < messageList.scrollTop + interconsultationButton.clientHeight;
      }
    },
    getInterconsultationUrl: function getInterconsultationUrl() {
      this.$helpers.goToProfessionalWebApp('patients/show/' + this.interconsultation.matterId, this.$apiToken);
    },
    acceptInterconsultation: function acceptInterconsultation() {
      var _this7 = this;

      var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].acceptOrDeclineInterconsultation(this.interconsultation.interconsultationId, accept).then(function (response) {
        if (response.status === 200) {
          if (response.data) {
            _this7.interconsultation.accepted = true;
            _this7.$store.dispatch('showSuccessAlert', _this7.$t('chats.accepted-consultation'));
          } else {
            _this7.deleteChatFromList(_this7.chatInfo.idAppointment);
            _this7.$store.dispatch('showDangerAlert', _this7.$t('chats.rejected-consultation'));
          }
        }
      });
    }
  },
  computed: {
    pastChat: function pastChat() {
      return this.$route.params.appointmentId;
    },
    isOpenedFromOuicare: function isOpenedFromOuicare() {
      return this.$route.query.professionalId != null || this.$route.query.patientId != null;
    },
    chatList: function chatList() {
      if (this.$store.getters['session/userIsProfessional'] && !this.isChatWithProfs) {
        return this.chats.filter(function (x) {
          return !x.isProfessional;
        });
      } else if (this.$store.getters['session/userIsProfessional']) {
        return this.chats.filter(function (x) {
          return x.isProfessional;
        });
      } else {
        return this.chats;
      }
    },
    anyActiveChats: function anyActiveChats() {
      return this.chatList.length !== 0;
    },
    firstUnreadMessageIndex: function firstUnreadMessageIndex() {
      return this.chatMessages.findIndex(function (msg) {
        return msg.received && !msg.read;
      });
    },
    firstInterconsultationIndex: function firstInterconsultationIndex() {
      var _this8 = this;

      return this.chatMessages.findIndex(function (msg) {
        return msg.appointmentId === _this8.chatInfo.idAppointment;
      });
    },
    isChatWithProfs: function isChatWithProfs() {
      return this.userType === __WEBPACK_IMPORTED_MODULE_12__constants_roles__["h" /* PROFESSIONAL_ROLE */];
    },
    defaultImg: function defaultImg() {
      return this.isChatWithProfs ? '/static-appopensalud/img/icons/morillas-svg-icons/primary/doctor.svg' : '/static-appopensalud/img/icons/morillas-svg-icons/primary/user.svg';
    },
    chatInfo: function chatInfo() {
      return this.$store.state.chat.selectedChat.user;
    },
    chatMessages: function chatMessages() {
      return this.$store.state.chat.selectedChat.messages;
    },
    dontAttendChatButton: function dontAttendChatButton() {
      return this.chatInfo.canCancel && this.$store.getters['session/userIsProfessional'] && this.chatInfo.withCompaniesServices;
    },
    showFinishButton: function showFinishButton() {
      return this.chatInfo.canFinish && !this.dontAttendChatButton;
    },
    interconsultation: function interconsultation() {
      return this.chatInfo.interconsultation;
    },
    interconsultationBlurred: function interconsultationBlurred() {
      return this.interconsultation && (!this.interconsultation.clinicHistoryAllowed || !this.interconsultationActiveAndAccepted);
    },
    interconsultationActiveAndAccepted: function interconsultationActiveAndAccepted() {
      return this.interconsultation.accepted && !this.chatInfo.terminated;
    },
    hasToAcceptInterconsultation: function hasToAcceptInterconsultation() {
      return this.interconsultation && !this.interconsultationActiveAndAccepted && !this.chatInfo.secondProf;
    },
    waitingForDoctorToAccept: function waitingForDoctorToAccept() {
      return this.interconsultation && !this.interconsultation.accepted && this.chatInfo.secondProf;
    }
  }
});

/***/ }),

/***/ 3493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_AudioPlayer_vue__ = __webpack_require__(3996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_BaseDialog__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_BaseButton_vue__ = __webpack_require__(122);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_0__components_utils_AudioPlayer_vue__["a" /* default */],
    ChatRepository: __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__["a" /* default */],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_3__components_base_BaseDialog__["default"],
    BIcon: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["C" /* BIcon */],
    BaseButton: __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_BaseButton_vue__["default"]
  },
  props: {
    msg: {
      type: Object,
      required: true
    },
    userPhoto: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      appointmentDateFormat: __WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__["a" /* appointmentDateFormat */],
      showFullImage: null
    };
  },

  methods: {
    showImageFullSize: function showImageFullSize() {
      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.showFullImage = src;
      if (src) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    toggleShowMsgOptions: function toggleShowMsgOptions(msgId) {
      this.$store.commit('chat/toggleShowMsgOptions', msgId === this.$store.state.chat.showMsgOptions ? null : msgId);
      if (this.$store.state.chat.showMsgOptions) {
        this.scrollToSeeEditMenu();
      }
    },
    scrollToSeeEditMenu: function scrollToSeeEditMenu() {
      var _this = this;

      this.$nextTick(function () {
        var listPos = _this.$store.state.chat.refs.messageList.getBoundingClientRect();
        var menuPos = _this.$refs.messageMenu.getBoundingClientRect();
        if (menuPos.top <= listPos.top || menuPos.bottom >= listPos.bottom) {
          _this.$store.state.chat.refs.messageList.scrollTo({
            top: _this.$store.state.chat.refs.messageList.scrollTop + _this.$refs.messageMenu.offsetHeight + 2,
            behavior: 'smooth'
          });
        }
      });
    },
    editMessage: function editMessage(msgId) {
      this.$store.commit('chat/setEditingMessage', this.$store.state.chat.selectedChat.messages.find(function (msg) {
        return !msg.received && msg.chatMessageId === msgId;
      }));
      this.$store.commit('chat/setNewMessage', this.$store.state.chat.editingMessage.text || '');
    }
  },
  computed: {
    showDeleteDialog: {
      get: function get() {
        return this.$store.state.chat.showDialog.delete && this.$store.state.chat.showMsgOptions === this.msg.chatMessageId;
      },
      set: function set(value) {}
    }
  }
});

/***/ }),

/***/ 3494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isPlaying: false,
            currentTime: 0,
            progress: 0
        };
    },

    props: {
        secondaryStyle: {
            type: Boolean,
            default: false
        },
        src: {
            type: String
        }
    },
    watch: {
        'progress': function progress(value) {
            if (value === 100) {
                this.progress = 0;
                this.$refs.audio.currentTime = 0;
                this.togglePlay();
            }
        }
    },
    methods: {
        togglePlay: function togglePlay() {
            var audio = this.$refs.audio;
            this.isPlaying ? audio.pause() : audio.play();
            this.isPlaying = !this.isPlaying;
        },
        updateProgress: function updateProgress() {
            var audio = this.$refs.audio;
            this.currentTime = audio.currentTime;
            this.progress = audio.currentTime / audio.duration * 100;
        },
        seekAudio: function seekAudio() {
            var audio = this.$refs.audio;
            audio.currentTime = this.progress / 100 * audio.duration;
        },
        setDuration: function setDuration() {
            var audio = this.$refs.audio;
            this.currentTime = audio.currentTime;
        }
    },
    filters: {
        formatTime: function formatTime(time) {
            var minutes = Math.floor(time / 60);
            var seconds = Math.floor(time % 60).toString().padStart(2, '0');
            return minutes + ':' + seconds;
        }
    }
});

/***/ }),

/***/ 3495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_consultationTypes__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_AppointmentsRepository__ = __webpack_require__(2599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_currencies__ = __webpack_require__(2550);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseDialog: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__["default"]
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        appointmentId: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            cancelReason: null,
            appointmentType: '',
            appointmentDetails: {},
            userInfo: {}
        };
    },

    methods: {
        cancelConsultation: function cancelConsultation() {
            var _this = this;

            if (!this.cancelReason) {
                this.$store.dispatch('showDangerAlert', this.$t('appointmentCancel.noCancelReason'));
            } else {
                // AppointmentsRepository.cancelAppointment(this.appointmentId, this.appointmentDetails.patientId, this.cancelReason).then((response) => {
                this.$ouicareApi.get('Agendas/CancelPersonalAppointmentProfessional', { appointmentID: this.appointmentId, idPaciente: this.appointmentDetails.patientId, Motivo: this.cancelReason }).then(function (response) {
                    if (response.data.status === 200) {
                        _this.$store.dispatch('showSuccessAlert', _this.$t('appointmentCancel.cancel-success'));
                        _this.cancelReason = null;
                        _this.$emit('toggleCancelAppointment');
                    } else {
                        _this.$store.dispatch('showDangerAlert', _this.$t('appointmentCancel.cancel-error'));
                    }
                });
            }
        }
    },
    computed: {
        formattedAppointmentDate: function formattedAppointmentDate() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_date_helpers__["a" /* appointmentDateFormat */])(this.appointmentDetails.fromDateTime);
        },
        currency: function currency() {
            return Object(__WEBPACK_IMPORTED_MODULE_4__constants_currencies__["a" /* getCurrencyByDomain */])();
        }
    },
    watch: {
        'showDialog': function showDialog(value) {
            var _this2 = this;

            if (value) {
                __WEBPACK_IMPORTED_MODULE_2__repositories_AppointmentsRepository__["a" /* default */].getAppointmentDetails(this.appointmentId).then(function (response) {
                    _this2.appointmentDetails = response.data.data;
                    _this2.appointmentType = Object(__WEBPACK_IMPORTED_MODULE_1__constants_consultationTypes__["u" /* getConsultationTitleById */])(response.data.data.type).toLowerCase();
                });
            }
        }
    }
});

/***/ }),

/***/ 3496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseTextarea_vue__ = __webpack_require__(525);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BIcon: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["C" /* BIcon */],
        BaseTextarea: __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseTextarea_vue__["default"]
    },
    data: function data() {
        return {
            recordingAudio: false,
            cancelAudio: false,

            mediaRecorder: null,
            audioChunks: [],
            startTime: null,
            elapsedTime: 0,
            intervalId: null
        };
    },

    methods: {
        uploadFile: function uploadFile(file) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (file) {
                                    _this.sendMessage(file);
                                } else {
                                    _this.$store.dispatch('showDangerAlert', _this.$t('chats.cant-upload-file'));
                                }

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        startRecording: function startRecording() {
            var _this2 = this;

            this.$store.commit('chat/toggleShowMsgOptions');

            navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
                _this2.recordingAudio = true;
                _this2.audioChunks = [];
                _this2.startTimer();
                _this2.mediaRecorder = new MediaRecorder(stream);
                _this2.mediaRecorder.start();

                _this2.mediaRecorder.ondataavailable = function (event) {
                    _this2.audioChunks.push(event.data);
                };
                _this2.mediaRecorder.onstop = _this2.onStopRecording;
            });
        },
        onStopRecording: function onStopRecording() {
            if (this.cancelAudio) {
                this.audioChunks = [];
                this.cancelAudio = false;
                return;
            }
            var audioBlob = new Blob(this.audioChunks, { type: 'audio/mpeg' });
            var audioFile = new File([audioBlob], 'recording.mpeg', { type: 'audio/mpeg' });
            this.uploadFile(audioFile);
        },
        sendAudio: function sendAudio() {
            if (!this.recordingAudio) return;
            this.recordingAudio = false;
            this.mediaRecorder.stop();
            this.stopTimer();
        },
        cancelRecording: function cancelRecording() {
            if (!this.recordingAudio) return;
            this.recordingAudio = false;
            this.cancelAudio = true;
            this.mediaRecorder.stop();
            this.stopTimer();
        },
        startTimer: function startTimer() {
            var _this3 = this;

            this.startTime = Date.now();
            this.intervalId = setInterval(function () {
                _this3.elapsedTime = Math.floor((Date.now() - _this3.startTime) / 1000);
            }, 1000);
        },
        stopTimer: function stopTimer() {
            clearInterval(this.intervalId);
            this.elapsedTime = 0;
        },
        sendMessage: function sendMessage() {
            var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.$store.dispatch('chat/sendMessage', file);
            this.$emit('sentMessage', this.$store.state.chat.selectedChat.user);
        }
    },
    computed: {
        formattedTime: function formattedTime() {
            var minutes = Math.floor(this.elapsedTime / 60);
            var seconds = this.elapsedTime % 60;
            return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
        }
    }
});

/***/ }),

/***/ 3991:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1ea55daa", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73c31155\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Chat.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73c31155\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Chat.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3992:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-73c31155]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-73c31155],.slide-down-leave-active[data-v-73c31155]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-73c31155],.slide-down-leave-to[data-v-73c31155]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-73c31155],.slide-fade-left-leave-active[data-v-73c31155]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-73c31155],.slide-fade-left-leave-to[data-v-73c31155]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-73c31155]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-73c31155],.fade-leave-to[data-v-73c31155]{opacity:0\n}\n.chat-container[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;height:90vh\n}\n@media (orientation: portrait){\n.chat-container[data-v-73c31155]{height:80vh\n}\n}\n.pending-chat-actions[data-v-73c31155]{pointer-events:none;-webkit-filter:blur(15px);filter:blur(15px)\n}\n.interconsultation-confirmation[data-v-73c31155]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;background:#eee;border-radius:23px !important;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);border:0px !important;-webkit-box-sizing:border-box;box-sizing:border-box;padding:3rem;z-index:5;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.chat-list[data-v-73c31155]{float:left;min-width:280px;width:33%;color:#8A8A8A;margin-right:0.5rem\n}\n@media (orientation: portrait){\n.chat-list[data-v-73c31155]{width:100%;margin-right:0\n}\n}\n.pat-profs-select[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:.8rem\n}\n.chat-card[data-v-73c31155]{background:#eee;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-radius:23px !important;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);border:0px !important;-webkit-box-sizing:border-box;box-sizing:border-box;height:100%;overflow-y:auto;overflow-x:hidden\n}\n.chat-list ul[data-v-73c31155]{border-radius:23px !important\n}\nul[data-v-73c31155]{margin-top:0;padding-left:0;margin-bottom:1rem\n}\n.chat-list-item[data-v-73c31155]{position:relative;font-size:0.9rem;padding:2rem 3rem;cursor:pointer\n}\n.chat-list-item[data-v-73c31155]:not(.selected):hover{background-color:#3238C4;color:#eee\n}\n.chat-list-item:not(.selected):hover .unread-messages[data-v-73c31155]{background:#eee;color:#3238C4\n}\n.chat-list-item:not(.selected):hover .chat-list-icon[data-v-73c31155]{-webkit-filter:invert(38%) brightness(200%) saturate(100%);filter:invert(38%) brightness(200%) saturate(100%)\n}\n.chat-list-item.selected[data-v-73c31155]{border-left:5px solid #3238C4;background-color:#fff\n}\n.item-block[data-v-73c31155]{text-overflow:ellipsis;overflow:hidden;display:inline-block;white-space:nowrap\n}\n.chat-list-photo[data-v-73c31155]{width:2.5rem;height:2.5rem;float:left;border-radius:50%;margin-right:1rem\n}\n.chat-list-photo.chat-list-icon[data-v-73c31155]{border-radius:0\n}\n.photo-align[data-v-73c31155]{padding-bottom:0.4rem\n}\n.contact-status[data-v-73c31155]{position:absolute;margin:-0.1rem 0 0 -0.1rem;width:0.6rem;height:0.6rem;border-radius:50%;border:1px solid #8A8A8A;background:#979797\n}\n.contact-status.connected[data-v-73c31155]{background:#6AEF89\n}\n.unread-messages[data-v-73c31155]{background:#3238C4;color:#eee;border-radius:20px;position:absolute;right:0.5rem;height:1.2rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0.5rem\n}\n.icon[data-v-73c31155]{height:1.3rem;width:2rem\n}\n.chat-box[data-v-73c31155]{width:67%;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n@media (orientation: portrait){\n.chat-box[data-v-73c31155]{width:100%\n}\n}\n.chat-box .interconsultation-button[data-v-73c31155]{width:100%;border-width:1px;border-color:#3238C4;background-color:#fff;color:#3238C4\n}\n.chat-box .interconsultation-button.anchored[data-v-73c31155]{position:absolute;right:0\n}\n.chat-box .interconsultation-button .subject[data-v-73c31155]{color:#1D1D1E\n}\n.chat-box .action-button[data-v-73c31155]{padding:.3rem .8rem !important\n}\n.chat-box .action-button span[data-v-73c31155]{font-size:0.8rem;padding-left:0.5rem\n}\n@media only screen and (max-width: 575px){\n.chat-box .action-button span[data-v-73c31155]{display:none\n}\n}\n.chat-header[data-v-73c31155]{width:100%;background-color:#fff;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.chat-header .back-arrow[data-v-73c31155]{float:left;margin:2rem 0 1rem 1rem;vertical-align:middle\n}\n.chat-header .photo[data-v-73c31155]{width:2.8rem;height:2.8rem;float:left;border-radius:50%;margin:1rem 1rem 0.75rem;vertical-align:middle\n}\n.chat-header p[data-v-73c31155]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;float:left;margin:0\n}\n.chat-header .chat-id[data-v-73c31155]{font-size:0.8rem;color:#979797;width:auto\n}\n@media only screen and (max-width: 575px){\n.chat-header .chat-id[data-v-73c31155]{font-size:0.7rem\n}\n}\n.user-info[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:0.6rem;width:60%\n}\n@media only screen and (max-width: 575px){\n.user-info[data-v-73c31155]{margin-top:0.75rem\n}\n}\n.chat-list-info[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.cancel-consultation[data-v-73c31155]{-webkit-box-align:right;-ms-flex-align:right;align-items:right;position:absolute;right:0;margin:1rem 1rem 0.75rem\n}\n.finish-consultation-options[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;cursor:pointer;z-index:3;margin-top:-0.25rem;padding-bottom:0.5rem\n}\n.finish-consultation-options p[data-v-73c31155]{margin:0.4rem\n}\n.finish-consultation-options>.e-prescription[data-v-73c31155],.finish-consultation-options>.finish-consultation[data-v-73c31155]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.finish-consultation-options>.e-prescription[data-v-73c31155]:only-child,.finish-consultation-options>.finish-consultation[data-v-73c31155]:only-child{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%\n}\n.chat-name[data-v-73c31155]{font-size:1.2rem\n}\n@media only screen and (max-width: 575px){\n.chat-name[data-v-73c31155]{font-size:1rem\n}\n}\n.chat-content[data-v-73c31155]{padding:10px;overflow-y:auto;-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.chat-content[data-v-73c31155]::-webkit-scrollbar{width:4px\n}\n.messages-pending-read[data-v-73c31155]{clear:both;text-align:center;font-weight:bold;background:-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,0)), to(rgba(0,0,0,0.15)));background:linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 100%)\n}\n.interconsultation-start[data-v-73c31155]{clear:both;text-align:center;background:-webkit-gradient(linear, left top, left bottom, from(#fff), to(#E4E4E4));background:linear-gradient(to bottom, #fff 0%, #E4E4E4 100%)\n}\n.scroll-end-btn[data-v-73c31155]{background:#fff;color:#3238C4;opacity:70%;border-radius:50%;width:2rem;height:2rem;border:none;cursor:pointer;padding:0.75rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;overflow:hidden;right:1em;bottom:8em\n}\n.z-2[data-v-73c31155]{z-index:2;opacity:1 !important\n}\n", ""]);

// exports


/***/ }),

/***/ 3993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessage_vue__ = __webpack_require__(3493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4bfcbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessage_vue__ = __webpack_require__(4000);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3994)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c4bfcbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4bfcbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/ChatMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c4bfcbc", Component.options)
  } else {
    hotAPI.reload("data-v-3c4bfcbc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3994:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3995);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("92b70fd8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c4bfcbc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c4bfcbc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3995:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-3c4bfcbc]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-3c4bfcbc],.slide-down-leave-active[data-v-3c4bfcbc]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-3c4bfcbc],.slide-down-leave-to[data-v-3c4bfcbc]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-3c4bfcbc],.slide-fade-left-leave-active[data-v-3c4bfcbc]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-3c4bfcbc],.slide-fade-left-leave-to[data-v-3c4bfcbc]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-3c4bfcbc]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-3c4bfcbc],.fade-leave-to[data-v-3c4bfcbc]{opacity:0\n}\n.message-block[data-v-3c4bfcbc]{display:block;clear:both;font-size:0.9rem;padding-bottom:0.5rem\n}\n[data-v-3c4bfcbc].sent{float:right\n}\n[data-v-3c4bfcbc].sent p{float:right;background-color:#3238C4;color:#eee\n}\n[data-v-3c4bfcbc].sent p a{color:#eee !important\n}\n[data-v-3c4bfcbc].sent p a:hover{color:#eee !important\n}\n[data-v-3c4bfcbc].sent img{background-color:#3238C4;color:#eee;float:right;cursor:pointer\n}\n[data-v-3c4bfcbc].sent .message-photo{float:right;margin-left:10px\n}\n[data-v-3c4bfcbc].sent .message-date{float:right\n}\n.received[data-v-3c4bfcbc]{float:left\n}\n.received p[data-v-3c4bfcbc]{float:left;background-color:#fff;color:#3238C4\n}\n.received img[data-v-3c4bfcbc]{background-color:#fff;color:#3238C4;float:left;cursor:pointer\n}\n.received .message-photo[data-v-3c4bfcbc]{float:left;margin-right:10px\n}\n.received .message-date[data-v-3c4bfcbc]{float:left\n}\n.chat-message[data-v-3c4bfcbc]{margin:.5rem 0;max-width:80%;padding:10px;border-radius:20px;white-space:pre-wrap\n}\n.chat-message.image-message[data-v-3c4bfcbc]{height:30rem;width:30rem;-o-object-fit:cover;object-fit:cover;cursor:pointer\n}\n.chat-message.document[data-v-3c4bfcbc]{-webkit-box-sizing:content-box;box-sizing:content-box\n}\n.chat-message.document button[data-v-3c4bfcbc]{border-width:1px\n}\n.chat-message.document button.sent[data-v-3c4bfcbc]{border-color:#fff\n}\n.chat-message.document button.received[data-v-3c4bfcbc]{border-color:#3238C4\n}\n.audio-message[data-v-3c4bfcbc]{margin:.5rem 0;max-width:80%\n}\n.message-photo[data-v-3c4bfcbc]{width:30px;height:30px;border-radius:50%;margin-top:0.8rem\n}\n.message-edit-delete[data-v-3c4bfcbc]{position:relative;background-color:#fff;color:#3238C4;border-radius:20px;z-index:3;padding:0.5rem 1rem;width:-webkit-min-content;width:-moz-min-content;width:min-content;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.message-edit-delete .message-edit-element[data-v-3c4bfcbc]{display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer\n}\n.message-edit-delete .delete[data-v-3c4bfcbc]{color:#FF7061\n}\n.message-date[data-v-3c4bfcbc]{display:block\n}\n.imgFullSize[data-v-3c4bfcbc]{position:fixed;top:0;left:0;width:100vw;height:100vh;background-color:rgba(0,0,0,0.8);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:3\n}\n.imgFullSize img[data-v-3c4bfcbc]{max-width:90%;max-height:90%;border-radius:8px\n}\n", ""]);

// exports


/***/ }),

/***/ 3996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioPlayer_vue__ = __webpack_require__(3494);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04dad0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioPlayer_vue__ = __webpack_require__(3999);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3997)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e04dad0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04dad0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioPlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/AudioPlayer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e04dad0e", Component.options)
  } else {
    hotAPI.reload("data-v-e04dad0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3997:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("463f5fe6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e04dad0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AudioPlayer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e04dad0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AudioPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3998:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-e04dad0e]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-e04dad0e],.slide-down-leave-active[data-v-e04dad0e]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-e04dad0e],.slide-down-leave-to[data-v-e04dad0e]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-e04dad0e],.slide-fade-left-leave-active[data-v-e04dad0e]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-e04dad0e],.slide-fade-left-leave-to[data-v-e04dad0e]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-e04dad0e]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-e04dad0e],.fade-leave-to[data-v-e04dad0e]{opacity:0\n}\n.audio-player[data-v-e04dad0e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px;border-radius:23px\n}\n.primary[data-v-e04dad0e]{background-color:#3238C4\n}\n.primary .play-pause-button[data-v-e04dad0e]{background-color:#3238C4;color:#fff\n}\n.primary input[type=\"range\"][data-v-e04dad0e]{color:#fff\n}\n.primary span[data-v-e04dad0e]{color:#fff\n}\n.secondary[data-v-e04dad0e]{background-color:#fff\n}\n.secondary .play-pause-button[data-v-e04dad0e]{background-color:#fff;color:#3238C4\n}\n.secondary input[type=\"range\"][data-v-e04dad0e]{color:#3238C4\n}\n.secondary span[data-v-e04dad0e]{color:#3238C4\n}\n.play-pause-button[data-v-e04dad0e]{border:none;display:-webkit-box;display:-ms-flexbox;display:flex\n}\ninput[type=\"range\"][data-v-e04dad0e]{margin:0 10px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:5px;border-radius:5px;background-color:#eee\n}\nspan[data-v-e04dad0e]{font-size:0.9rem\n}\n.icon[data-v-e04dad0e]{height:1.3rem;width:2rem\n}\n", ""]);

// exports


/***/ }),

/***/ 3999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex" }, [
    _c(
      "div",
      { class: ["audio-player", _vm.secondaryStyle ? "secondary" : "primary"] },
      [
        _c(
          "button",
          { staticClass: "play-pause-button", on: { click: _vm.togglePlay } },
          [
            _vm.isPlaying
              ? _c("b-icon-pause-fill", { staticClass: "icon" })
              : _c("b-icon-play-fill", { staticClass: "icon" })
          ],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.progress,
              expression: "progress"
            }
          ],
          staticClass: "audio-bar",
          attrs: { type: "range", max: "100" },
          domProps: { value: _vm.progress },
          on: {
            input: _vm.seekAudio,
            __r: function($event) {
              _vm.progress = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("formatTime")(_vm.currentTime)))])
      ]
    ),
    _vm._v(" "),
    _c(
      "audio",
      {
        ref: "audio",
        attrs: { preload: "auto" },
        on: { timeupdate: _vm.updateProgress, loadedmetadata: _vm.setDuration }
      },
      [_c("source", { attrs: { src: _vm.src, type: "audio/mpeg" } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e04dad0e", esExports)
  }
}

/***/ }),

/***/ 4000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["message-block", _vm.msg.received ? "received" : "sent"] },
    [
      _vm.msg.received
        ? _c("img", {
            staticClass: "message-photo",
            attrs: { src: _vm.userPhoto, alt: "" }
          })
        : _c("img", {
            staticClass: "message-photo",
            attrs: { src: _vm.$store.state.session.user.photo, alt: "" }
          }),
      _vm._v(" "),
      !_vm.msg.file
        ? _c("p", {
            staticClass: "chat-message",
            domProps: { innerHTML: _vm._s(_vm.msg.text) }
          })
        : _vm.msg.file.contentType.includes("audio")
        ? _c("audio-player", {
            staticClass: "audio-message",
            attrs: {
              secondaryStyle: _vm.msg.received,
              src: _vm.msg.file.fileUrl
            }
          })
        : _vm.msg.file.contentType.includes("image")
        ? _c("img", {
            staticClass: "chat-message image-message",
            attrs: { src: _vm.msg.file.fileUrl, alt: "" },
            on: {
              click: function($event) {
                return _vm.showImageFullSize(_vm.msg.file.fileUrl)
              }
            }
          })
        : _c("p", { staticClass: "chat-message document" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.msg.file.fileUrl,
                  target: "_blank",
                  download: _vm.msg.file.name
                }
              },
              [
                _c(
                  "base-button",
                  {
                    class: [_vm.msg.received ? "received" : "sent"],
                    attrs: { white: _vm.msg.received }
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("b-icon-file-earmark-text"),
                        _vm._v("  " + _vm._s(_vm.msg.file.name))
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c("div", [
        _vm.msg.received || _vm.$store.state.chat.selectedChat.user.terminated
          ? _c("span", { staticClass: "message-date" }, [
              _vm._v(_vm._s(_vm.appointmentDateFormat(_vm.msg.date, true))),
              _vm.msg.edited
                ? _c("span", [_vm._v(" | " + _vm._s(_vm.$t("edited")))])
                : _vm._e()
            ])
          : _c("div", [
              _c(
                "span",
                { staticClass: "message-date" },
                [
                  _c("b-icon-three-dots", {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.toggleShowMsgOptions(_vm.msg.chatMessageId)
                      }
                    }
                  }),
                  _vm.msg.edited
                    ? _c("span", [_vm._v(" | " + _vm._s(_vm.$t("edited")))])
                    : _vm._e(),
                  _vm._v(" | "),
                  _vm.msg.read ? _c("b-icon-eye") : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.appointmentDateFormat(_vm.msg.date, true)) +
                      "\n        "
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$store.state.chat.showMsgOptions ===
                            _vm.msg.chatMessageId,
                          expression:
                            "$store.state.chat.showMsgOptions === msg.chatMessageId"
                        }
                      ],
                      ref: "messageMenu",
                      staticClass: "message-edit-delete"
                    },
                    [
                      _c("div", { staticClass: "mb-1" }, [
                        !_vm.msg.file
                          ? _c(
                              "span",
                              {
                                staticClass: "message-edit-element mr-3",
                                on: {
                                  click: function($event) {
                                    return _vm.editMessage(
                                      _vm.msg.chatMessageId
                                    )
                                  }
                                }
                              },
                              [
                                _c("b-icon-pencil", {
                                  staticClass: "mt-1 mr-1"
                                }),
                                _vm._v(_vm._s(_vm.$t("edit")))
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "message-edit-element delete",
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  "chat/toggleShowDialog",
                                  "delete"
                                )
                              }
                            }
                          },
                          [
                            _c("b-icon-trash", { staticClass: "mt-1 mr-1" }),
                            _vm._v(_vm._s(_vm.$t("chats.delete")))
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
      ]),
      _vm._v(" "),
      _vm.showFullImage
        ? _c(
            "div",
            {
              staticClass: "imgFullSize",
              on: {
                click: function($event) {
                  return _vm.showImageFullSize()
                }
              }
            },
            [_c("img", { attrs: { src: _vm.showFullImage, alt: "" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("chats.delete-message"),
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          okFn: function() {
            _vm.$store.dispatch("chat/deleteMessage", _vm.msg.chatMessageId)
          },
          cancelFn: function() {
            _vm.$store.commit("chat/toggleShowDialog", "delete")
          }
        },
        model: {
          value: _vm.showDeleteDialog,
          callback: function($$v) {
            _vm.showDeleteDialog = $$v
          },
          expression: "showDeleteDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c4bfcbc", esExports)
  }
}

/***/ }),

/***/ 4001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
var client=function client(){return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;};/* harmony default export */ __webpack_exports__["a"] = ({createChipcardSession:function createChipcardSession(patientId,appointmentId){return client().get('Chipcard/CreateChipcardSession',{params:{idCita:appointmentId,idPatient:patientId}});}});

/***/ }),

/***/ 4002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelAppointmentModal_vue__ = __webpack_require__(3495);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef8b480_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelAppointmentModal_vue__ = __webpack_require__(4005);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4003)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelAppointmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef8b480_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelAppointmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/shared/CancelAppointmentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ef8b480", Component.options)
  } else {
    hotAPI.reload("data-v-3ef8b480", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4003:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4004);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("fba88fe4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ef8b480\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CancelAppointmentModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ef8b480\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CancelAppointmentModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4004:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.details-photo{width:8rem;height:8rem;border-radius:50%;margin:1rem 1rem 0.75rem;vertical-align:middle\n}\n@media only screen and (max-width: 575px){\n.details-photo{width:5rem;height:5rem\n}\n}\n.details-container{height:10rem;text-align:center\n}\n.appointment-container{padding-left:1.5rem\n}\n@media only screen and (max-width: 575px){\n.appointment-container{padding-top:1.5rem;padding-left:0\n}\n}\n.details-text{margin:0.4rem 0;font-size:0.9rem\n}\n@media only screen and (max-width: 575px){\n.details-text{font-size:0.8rem\n}\n}\n.details-name{margin-top:0.4rem;font-size:1.2rem;margin-bottom:0.1rem\n}\n@media only screen and (max-width: 575px){\n.details-name{font-size:1rem\n}\n}\n.reason-container{padding-top:1.5rem\n}\n.message-text{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n", ""]);

// exports


/***/ }),

/***/ 4005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            keepOpened: "",
            title:
              _vm.$t("appointmentCancel.cancel") + " " + _vm.appointmentType,
            okBtnText:
              _vm.$t("appointmentCancel.wantToCancel") +
              " (" +
              _vm.appointmentType +
              ")",
            okBtnVariant: "danger",
            cancelBtnText: _vm.$t("back"),
            cancelBtnVariant: "secondary",
            okFn: function() {
              _vm.cancelConsultation()
            },
            cancelFn: function() {
              _vm.$emit("toggleCancelAppointment")
            }
          },
          model: {
            value: _vm.showDialog,
            callback: function($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog"
          }
        },
        [
          [
            _vm.appointmentDetails.patientData
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        attrs: {
                          cols: "12",
                          xs: "12",
                          md: "6",
                          lg: "6",
                          xl: "6"
                        }
                      },
                      [
                        _c("b-row", [
                          _c("h5", [
                            _vm._v(
                              _vm._s(_vm.$t("appointmentCancel.patientData"))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "align-items-center" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "5", xs: "5" } },
                              [
                                _c("b-row", [
                                  _c("img", {
                                    staticClass: "details-photo",
                                    attrs: {
                                      src:
                                        _vm.appointmentDetails.patientData
                                          .photo,
                                      alt: ""
                                    }
                                  })
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "details-container",
                                attrs: { cols: "7", xs: "7" }
                              },
                              [
                                _c("b-row", [
                                  _c("p", { staticClass: "details-name" }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.appointmentDetails.patientData
                                            .fullName
                                        )
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData
                                          .fullAddress
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData.email
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData
                                          .phonenumber
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "appointment-container",
                        attrs: {
                          cols: "12",
                          xs: "12",
                          md: "6",
                          lg: "6",
                          xl: "6"
                        }
                      },
                      [
                        _c("b-row", [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("appointmentCancel.appointmentSummary")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.$t("date") + ":"))
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(_vm.formattedAppointmentDate)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.appointmentDetails.duration
                                  ? _c("b-row", [
                                      _c("p", { staticClass: "details-text" }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("duration") + ":")
                                          )
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.appointmentDetails.duration
                                            )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.$t("price") + ":"))
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.appointmentDetails.price) +
                                        " " +
                                        _vm._s(_vm.currency)
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "reason-container" },
              [
                _c("b-row", [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("appointmentCancel.cancelationReason"))
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("base-textarea", {
                  staticClass: "message-text mt-2",
                  attrs: {
                    rows: 1,
                    "max-rows": 5,
                    placeholder: _vm.$t("appointmentCancel.writeAReason")
                  },
                  model: {
                    value: _vm.cancelReason,
                    callback: function($$v) {
                      _vm.cancelReason = $$v
                    },
                    expression: "cancelReason"
                  }
                })
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ef8b480", esExports)
  }
}

/***/ }),

/***/ 4006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessageInput_vue__ = __webpack_require__(3496);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d25bc78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessageInput_vue__ = __webpack_require__(4009);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4007)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d25bc78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessageInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d25bc78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessageInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/ChatMessageInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d25bc78", Component.options)
  } else {
    hotAPI.reload("data-v-7d25bc78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4007:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4008);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("56b22f16", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d25bc78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessageInput.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d25bc78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessageInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4008:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-7d25bc78]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-7d25bc78],.slide-down-leave-active[data-v-7d25bc78]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-7d25bc78],.slide-down-leave-to[data-v-7d25bc78]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-7d25bc78],.slide-fade-left-leave-active[data-v-7d25bc78]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-7d25bc78],.slide-fade-left-leave-to[data-v-7d25bc78]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-7d25bc78]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-7d25bc78],.fade-leave-to[data-v-7d25bc78]{opacity:0\n}\n.message-input[data-v-7d25bc78]{width:100%;z-index:2;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:1rem;padding-bottom:1rem\n}\n.message-input[data-v-7d25bc78] .message-text .form-group{margin-bottom:0 !important\n}\n.message-input[data-v-7d25bc78] .message-text textarea{background:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:left\n}\n.message-input[data-v-7d25bc78] .message-text textarea::-webkit-input-placeholder{display:-webkit-box;display:flex\n}\n.message-input[data-v-7d25bc78] .message-text textarea::-moz-placeholder{display:flex\n}\n.message-input[data-v-7d25bc78] .message-text textarea::-ms-input-placeholder{display:-ms-flexbox;display:flex\n}\n.message-input[data-v-7d25bc78] .message-text textarea::placeholder{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.message-input .message-text[data-v-7d25bc78]::-webkit-scrollbar{display:none\n}\n.message-input .chat-input-buttons[data-v-7d25bc78]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.message-input .icon-btn[data-v-7d25bc78]{background:#3238C4;color:#eee;border-radius:50%;width:3rem;height:3rem;border:none;cursor:pointer;padding:0.75rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.message-input .recorder[data-v-7d25bc78]{height:61px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.message-input .recorder span[data-v-7d25bc78]{position:absolute;right:0;padding-right:1rem\n}\n.message-input .recorder .recording.icon[data-v-7d25bc78]{color:#FF7061\n}\n.message-input .icon-btn.cancel[data-v-7d25bc78]{background:#FF7061\n}\n.icon[data-v-7d25bc78]{height:1.3rem;width:2rem\n}\n", ""]);

// exports


/***/ }),

/***/ 4009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.chat.editingMessage
        ? _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("base-textarea", {
                    staticClass: "message-text",
                    attrs: {
                      rows: 1,
                      "max-rows": 5,
                      placeholder: _vm.$t("chats.new-message")
                    },
                    model: {
                      value: _vm.$store.state.chat.newMessage,
                      callback: function($$v) {
                        _vm.$set(_vm.$store.state.chat, "newMessage", $$v)
                      },
                      expression: "$store.state.chat.newMessage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.$store.dispatch("chat/editMessage")
                        }
                      }
                    },
                    [_c("b-icon-check-lg", { staticClass: "icon" })],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn cancel",
                      on: {
                        click: function($event) {
                          return _vm.$store.commit("chat/resetMsg")
                        }
                      }
                    },
                    [_c("b-icon-x-lg", { staticClass: "icon" })],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm.recordingAudio
        ? _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("div", { staticClass: "recorder" }, [
                    _c(
                      "span",
                      [
                        _c("b-icon-circle-fill", {
                          staticClass: "recording icon",
                          attrs: { animation: "throb" }
                        }),
                        _vm._v(_vm._s(_vm.formattedTime))
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn cancel",
                      on: {
                        click: function($event) {
                          return _vm.cancelRecording()
                        }
                      }
                    },
                    [_c("b-icon-trash-fill", { staticClass: "icon" })],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.sendAudio()
                        }
                      }
                    },
                    [_c("b-icon-cursor-fill", { staticClass: "icon" })],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("base-textarea", {
                    staticClass: "message-text",
                    attrs: {
                      rows: 1,
                      "max-rows": 5,
                      placeholder: _vm.$t("chats.new-message")
                    },
                    model: {
                      value: _vm.$store.state.chat.newMessage,
                      callback: function($$v) {
                        _vm.$set(_vm.$store.state.chat, "newMessage", $$v)
                      },
                      expression: "$store.state.chat.newMessage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.$refs.fileInput.click()
                        }
                      }
                    },
                    [
                      _c("b-icon-paperclip", { staticClass: "icon" }),
                      _c("input", {
                        ref: "fileInput",
                        staticClass: "d-none",
                        attrs: { type: "file" },
                        on: {
                          change: function($event) {
                            return _vm.uploadFile($event.target.files[0])
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _vm.$store.state.chat.newMessage !== ""
                    ? _c(
                        "button",
                        {
                          staticClass: "icon-btn",
                          on: {
                            click: function($event) {
                              return _vm.sendMessage()
                            }
                          }
                        },
                        [_c("b-icon-cursor-fill", { staticClass: "icon" })],
                        1
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "icon-btn",
                          on: {
                            click: function($event) {
                              return _vm.startRecording()
                            }
                          }
                        },
                        [_c("b-icon-mic-fill", { staticClass: "icon" })],
                        1
                      )
                ]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d25bc78", esExports)
  }
}

/***/ }),

/***/ 4010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-container" },
    [
      (_vm.anyActiveChats && !_vm.chatInfo && _vm.$uiHelpers.isPortrait) ||
      !_vm.$uiHelpers.isPortrait
        ? _c("div", { staticClass: "chat-list chat-card" }, [
            _vm.$store.getters["session/userIsProfessional"]
              ? _c(
                  "div",
                  { staticClass: "pat-profs-select" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "mr-1 d-flex justify-content-center",
                        staticStyle: { width: "50%" },
                        attrs: { white: _vm.isChatWithProfs },
                        on: {
                          click: function($event) {
                            return _vm.setUserType(_vm.PATIENT_ROLE)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("chats.patients")))])]
                    ),
                    _c(
                      "base-button",
                      {
                        staticClass: "ml-1 d-flex justify-content-center",
                        staticStyle: { width: "50%" },
                        attrs: { white: !_vm.isChatWithProfs },
                        on: {
                          click: function($event) {
                            return _vm.setUserType(_vm.PROFESSIONAL_ROLE)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chats.professionals")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "ul",
                [
                  _vm.$store.getters["session/userIsProfessional"]
                    ? _c(
                        "li",
                        {
                          staticClass: "chat-list-item",
                          on: {
                            click: function($event) {
                              return _vm.contactUser()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "photo-name-wrapper" }, [
                            _c("div", { staticClass: "photo-align" }, [
                              _c("img", {
                                staticClass: "chat-list-photo chat-list-icon",
                                attrs: { src: _vm.defaultImg, alt: "" }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.isChatWithProfs
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chats.contact-prof")))
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("chats.contact-patient"))
                                  )
                                ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.chatList, function(chat) {
                    return _c(
                      "li",
                      {
                        key: chat.idAppointment,
                        staticClass: "chat-list-item",
                        class: [_vm.chatInfo === chat ? "selected" : ""],
                        on: {
                          click: function($event) {
                            return _vm.selectChat(chat)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "photo-name-wrapper" }, [
                          _c(
                            "div",
                            {
                              class: [
                                !chat.createdByDoctor ? "photo-align" : ""
                              ]
                            },
                            [
                              _c("span", {
                                staticClass: "contact-status",
                                class: [
                                  chat.conexionState === "online"
                                    ? "connected"
                                    : ""
                                ]
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "chat-list-photo",
                                attrs: { src: chat.urlPhoto, alt: "" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("b-row", { staticClass: "item-block" }, [
                                _c("span", [_vm._v(_vm._s(chat.name))])
                              ]),
                              _vm._v(" "),
                              chat.interconsultation
                                ? _c(
                                    "b-row",
                                    { staticClass: "item-block" },
                                    [
                                      _c("b-icon-person-fill", {
                                        staticClass:
                                          "align-items-center mt-1 mr-1"
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(chat.interconsultation.subject)
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          chat.numMessagesPendingRead
                            ? _c("span", { staticClass: "unread-messages" }, [
                                _vm._v(_vm._s(chat.numMessagesPendingRead))
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.pastChat
                    ? _c(
                        "li",
                        {
                          staticClass: "chat-list-item",
                          on: {
                            "~click": function($event) {
                              return _vm.getAllChats()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "photo-name-wrapper" }, [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chats.view-all")))
                            ])
                          ])
                        ]
                      )
                    : _c(
                        "li",
                        {
                          staticClass: "chat-list-item",
                          on: {
                            "~click": function($event) {
                              return _vm.getPastChats()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "photo-name-wrapper" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chats.finished-chats")))
                            ])
                          ])
                        ]
                      )
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.chatInfo
        ? _c("div", { staticClass: "chat-box chat-card" }, [
            _c(
              "div",
              { staticClass: "chat-header" },
              [
                _vm.$uiHelpers.isPortrait
                  ? _c("b-icon-arrow-left", {
                      staticClass: "back-arrow",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.$store.commit("chat/unselectChat")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("img", {
                  staticClass: "photo",
                  attrs: { src: _vm.chatInfo.urlPhoto, alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "user-info",
                    style: _vm.chatInfo.customPageUrl ? "cursor: pointer;" : "",
                    on: { click: _vm.goToProfPage }
                  },
                  [
                    _c("b-row", [
                      _c("p", { staticClass: "chat-name" }, [
                        _vm._v(_vm._s(_vm.chatInfo.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-row", [
                      _c("p", { staticClass: "chat-id" }, [
                        _vm._v("Id: " + _vm._s(_vm.chatInfo.idAppointment))
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.chatInfo.canCancel
                  ? _c(
                      "div",
                      { staticClass: "cancel-consultation" },
                      [
                        _vm.dontAttendChatButton
                          ? _c(
                              "base-button",
                              {
                                staticClass: "action-button",
                                attrs: { red: "", textColor: _vm.SECONDARY },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleShowDialog("dontAttend")
                                  }
                                }
                              },
                              [
                                _c("b-icon-x-circle"),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("chats.dont-attend-chat"))
                                  )
                                ])
                              ],
                              1
                            )
                          : _c(
                              "base-button",
                              {
                                staticClass: "action-button",
                                attrs: { red: "", textColor: _vm.SECONDARY },
                                on: {
                                  click: function($event) {
                                    return _vm.goCancelAppointment()
                                  }
                                }
                              },
                              [
                                _c("b-icon-x-circle"),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chats.cancel-chat")))
                                ])
                              ],
                              1
                            )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasToAcceptInterconsultation
              ? _c("div", { staticClass: "interconsultation-confirmation" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chats.new-interconsultation")))
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _c("span", [_vm._v(_vm._s(_vm.interconsultation.subject))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "mt-2",
                          on: {
                            click: function($event) {
                              return _vm.acceptInterconsultation(true)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("dialog.ok-button")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          staticClass: "mt-2",
                          attrs: { red: "", textColor: _vm.SECONDARY },
                          on: {
                            click: function($event) {
                              return _vm.acceptInterconsultation()
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("dialog.reject-button")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm.waitingForDoctorToAccept
              ? _c(
                  "div",
                  { staticClass: "interconsultation-confirmation " },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("chats.not-yet-accepted-interconsultation")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "base-button",
                      {
                        staticClass: "mt-2",
                        attrs: { red: "", textColor: _vm.SECONDARY },
                        on: {
                          click: function($event) {
                            return _vm.acceptInterconsultation()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cancel") +
                                " " +
                                _vm.$t("chats.interconsultation")
                            )
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.interconsultation &&
            _vm.interconsultation.accepted &&
            !_vm.interconsultation.clinicHistoryAllowed
              ? _c("div", { staticClass: "interconsultation-confirmation " }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chats.waiting-for-clinic-history")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.interconsultation && _vm.showInterconsultationAnchored
              ? _c(
                  "div",
                  {
                    class: [
                      "z-2",
                      _vm.interconsultationBlurred ? "pending-chat-actions" : ""
                    ]
                  },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "interconsultation-button anchored",
                        on: {
                          click: function($event) {
                            return _vm.getInterconsultationUrl()
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("b-icon-person"),
                            _vm._v(
                              " " + _vm._s(_vm.interconsultation.matterName)
                            )
                          ],
                          1
                        ),
                        _c("br"),
                        _c("span", { staticClass: "subject" }, [
                          _vm._v(_vm._s(_vm.interconsultation.subject))
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "messageList",
                class: [
                  "chat-content",
                  _vm.interconsultationBlurred ? "pending-chat-actions" : ""
                ],
                on: {
                  "&scroll": function($event) {
                    return _vm.handleScroll()
                  }
                }
              },
              [
                _c(
                  "ul",
                  _vm._l(_vm.chatMessages, function(msg, index) {
                    return _c(
                      "li",
                      { key: msg.chatMessageId },
                      [
                        _vm.$store.state.chat.messagesPendingReadLabel > 0 &&
                        index === _vm.firstUnreadMessageIndex
                          ? _c("div", {
                              ref: "messagesPendingRead",
                              refInFor: true,
                              staticClass: "messages-pending-read"
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.interconsultation &&
                        index === _vm.firstInterconsultationIndex
                          ? _c(
                              "base-button",
                              {
                                ref: "interconsultationButton",
                                refInFor: true,
                                staticClass: "interconsultation-button mt-5",
                                on: {
                                  click: function($event) {
                                    return _vm.getInterconsultationUrl()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("b-icon-person"),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.interconsultation.matterName)
                                    )
                                  ],
                                  1
                                ),
                                _c("br"),
                                _c("span", { staticClass: "subject" }, [
                                  _vm._v(_vm._s(_vm.interconsultation.subject))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("chat-message", {
                          attrs: { msg: msg, userPhoto: _vm.chatInfo.urlPhoto }
                        })
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("base-dialog", {
                  attrs: {
                    content: _vm.$t("chats.finish-chat-message"),
                    okBtnText: _vm.$t("yes"),
                    cancelBtnText: _vm.$t("no"),
                    okFn: function() {
                      _vm.finishChatMessage()
                    },
                    cancelFn: function() {
                      _vm.toggleShowDialog("finish")
                    }
                  },
                  model: {
                    value: _vm.$store.state.chat.showDialog.finish,
                    callback: function($$v) {
                      _vm.$set(_vm.$store.state.chat.showDialog, "finish", $$v)
                    },
                    expression: "$store.state.chat.showDialog.finish"
                  }
                }),
                _vm._v(" "),
                _c("base-dialog", {
                  attrs: {
                    content: _vm.$t("chats.emit-eprescription-message"),
                    okBtnText: _vm.$t("continue"),
                    okFn: function() {
                      _vm.emitEPrescription()
                    },
                    cancelFn: function() {
                      _vm.toggleShowDialog("ePrescription")
                    }
                  },
                  model: {
                    value: _vm.$store.state.chat.showDialog.ePrescription,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.$store.state.chat.showDialog,
                        "ePrescription",
                        $$v
                      )
                    },
                    expression: "$store.state.chat.showDialog.ePrescription"
                  }
                }),
                _vm._v(" "),
                _c("base-dialog", {
                  attrs: {
                    content: _vm.$t("chats.reassign-chat"),
                    okBtnText: _vm.$t("continue"),
                    okFn: function() {
                      _vm.reassignChat()
                    },
                    cancelFn: function() {
                      _vm.toggleShowDialog("dontAttend")
                    }
                  },
                  model: {
                    value: _vm.$store.state.chat.showDialog.dontAttend,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.$store.state.chat.showDialog,
                        "dontAttend",
                        $$v
                      )
                    },
                    expression: "$store.state.chat.showDialog.dontAttend"
                  }
                }),
                _vm._v(" "),
                _c("cancel-appointment-modal", {
                  attrs: {
                    showDialog: _vm.$store.state.chat.showDialog.cancel,
                    appointmentId: _vm.chatInfo.idAppointment
                  },
                  on: {
                    toggleCancelAppointment: function($event) {
                      return _vm.toggleShowDialog("cancel")
                    }
                  }
                }),
                _vm._v(" "),
                _c("consolidate-appointment-modal", {
                  attrs: {
                    value: _vm.showFinishModal,
                    isBillable: _vm.chatInfo.showBillingSelectorOnConsolidate,
                    billingEntity: _vm.chatInfo.useCenterBillingInfo
                  },
                  on: { consolidate: _vm.consolidateChat }
                }),
                _vm._v(" "),
                _vm.showScrollBottomButton
                  ? _c(
                      "button",
                      {
                        staticClass: "scroll-end-btn",
                        on: {
                          click: function($event) {
                            return _vm.$uiHelpers.scrollBottom(
                              _vm.$refs.messageList,
                              true
                            )
                          }
                        }
                      },
                      [_c("b-icon-arrow-down", { staticClass: "icon" })],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            !_vm.chatInfo.terminated
              ? _c(
                  "div",
                  {
                    ref: "messageInput",
                    class: [
                      _vm.interconsultationBlurred ? "pending-chat-actions" : ""
                    ]
                  },
                  [
                    _c("chat-message-input", {
                      on: { sentMessage: _vm.setChatFirst }
                    }),
                    _vm._v(" "),
                    _vm.showFinishButton || _vm.chatInfo.ePrescriptionAvailable
                      ? _c(
                          "b-row",
                          { staticClass: "finish-consultation-options" },
                          [
                            _vm.chatInfo.ePrescriptionAvailable
                              ? _c(
                                  "b-row",
                                  { staticClass: "e-prescription" },
                                  [
                                    _c(
                                      "base-button",
                                      {
                                        staticClass: "action-button",
                                        attrs: { textColor: _vm.SECONDARY },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleShowDialog(
                                              "ePrescription"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("b-icon-file-medical"),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("chats.emit-eprescription")
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showFinishButton
                              ? _c(
                                  "b-row",
                                  { staticClass: "finish-consultation" },
                                  [
                                    _c(
                                      "base-button",
                                      {
                                        staticClass: "action-button",
                                        attrs: {
                                          red: "",
                                          textColor: _vm.SECONDARY
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleShowDialog(
                                              "finish"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("b-icon-telephone-x-fill"),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("chats.finish-chat"))
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm.chatInfo.terminated && !_vm.chatInfo.reviewed
              ? _c(
                  "div",
                  {
                    class: [
                      "d-flex",
                      "justify-content-center",
                      _vm.interconsultationBlurred ? "pending-chat-actions" : ""
                    ]
                  },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "mb-3",
                        on: {
                          click: function($event) {
                            return _vm.$helpers.goToPatientWebApp(
                              "appointments/review/" +
                                _vm.chatInfo.idAppointment,
                              _vm.$apiToken
                            )
                          }
                        }
                      },
                      [
                        _c("b-icon-hand-thumbs-up-fill", {
                          staticClass: "mr-2"
                        }),
                        _c("span", [_vm._v(_vm._s(this.$t("review")))])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : !_vm.anyActiveChats
        ? _c("div", { staticClass: "chat-box chat-card " }, [
            _vm.$store.getters["session/userIsProfessional"] &&
            _vm.$uiHelpers.isPortrait
              ? _c(
                  "div",
                  { staticClass: "pat-profs-select" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "mr-1 d-flex justify-content-center",
                        staticStyle: { width: "50%" },
                        attrs: { white: _vm.isChatWithProfs },
                        on: {
                          click: function($event) {
                            return _vm.setUserType(_vm.PATIENT_ROLE)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("chats.patients")))])]
                    ),
                    _c(
                      "base-button",
                      {
                        staticClass: "ml-1 d-flex justify-content-center",
                        staticStyle: { width: "50%" },
                        attrs: { white: !_vm.isChatWithProfs },
                        on: {
                          click: function($event) {
                            return _vm.setUserType(_vm.PROFESSIONAL_ROLE)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chats.professionals")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column align-items-center justify-content-center flex-grow-1"
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("chats.no-active-chat")))]),
                _vm._v(" "),
                _vm.$store.getters["session/userIsPatient"]
                  ? _c(
                      "base-button",
                      {
                        staticClass: "mt-2",
                        on: {
                          click: function($event) {
                            return _vm.$router.push(
                              "/patient/search?appointmentType=" + _vm.CHAT
                            )
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chats.ask-for-new-chat")))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters["session/userIsProfessional"]
                  ? _c(
                      "base-button",
                      {
                        staticClass: "mt-2",
                        on: {
                          click: function($event) {
                            return _vm.contactUser()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              "" +
                                (_vm.isChatWithProfs
                                  ? _vm.$t("chats.contact-prof")
                                  : _vm.$t("chats.contact-patient"))
                            )
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$uiHelpers.isPortrait
                  ? _c(
                      "base-button",
                      {
                        staticClass: "mt-2",
                        on: {
                          click: function($event) {
                            return _vm.getPastChats()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(this.$t("chats.finished-chats")))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("administrative-chat-modal", {
        attrs: {
          isChatWithProf: _vm.isChatWithProfs,
          openedFromOuicare: _vm.isOpenedFromOuicare
        },
        on: { createAdministrativeChat: _vm.createChat }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "photo-align" }, [
      _c("img", {
        staticClass: "chat-list-photo chat-list-icon",
        attrs: {
          src:
            "/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "photo-align" }, [
      _c("img", {
        staticClass: "chat-list-photo chat-list-icon",
        attrs: {
          src:
            "/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73c31155", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/14.3a872be4aed78c4935d4.js